export const AdobeLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        id="control_strip_-_welcome"
        data-name="control strip - welcome"
        transform="translate(0.5 0.881)"
      >
        <g
          id="Group_67925"
          data-name="Group 67925"
          transform="translate(-0.5 -0.881)"
        >
          <rect id="ToDelete" width="24" height="24" fill="#fff" opacity="0" />
          <path
            id="Path_39000"
            data-name="Path 39000"
            d="M13.218,3.5H19.81V20.228Z"
            transform="translate(1.652 0.087)"
            fill="#000"
          />
          <path
            id="Path_39001"
            data-name="Path 39001"
            d="M9.1,3.5H2.5V20.228Z"
            transform="translate(0.123 0.087)"
            fill="#000"
          />
          <path
            id="Path_39002"
            data-name="Path 39002"
            d="M11.138,9.023l4.2,9.931H12.587l-1.259-3.163H8.252Z"
            transform="translate(0.951 1.078)"
            fill="#000"
          />
        </g>
      </g>
    </svg>
  );
};

export const UserArrowIcon = () => {
  return (
    <svg
      style={{ margin: "0 auto" }}
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      fill="000000"
    >
      <rect id="Canvas" fill="#E6E6E6" opacity="0" width="18" height="18" />
      <path
        fill="#FFFFFF"
        d="M5.437,9.811A.25.25,0,0,0,5,9.977V12H1.5a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5H5v1.909a.25.25,0,0,0,.437.166L9,13.5Z"
      />
      <path
        fill="#FFFFFF"
        d="M13.1275,9.8875a.719.719,0,0,1-.622-.7215V8.1245a.72049.72049,0,0,1,.1835-.465,5.5,5.5,0,0,0,1.25-3.433c0-2.6-1.378-4.05-3.4595-4.05s-3.5,1.509-3.5,4.05A5.562,5.562,0,0,0,8.302,7.673a.694.694,0,0,1,.172.45V9.186a.7.7,0,0,1-.684.697L11.2845,13.5,9.7895,15H17.968c.003-.3655.0055-.7085.0055-.763C17.9735,13.1555,17.2345,10.3045,13.1275,9.8875Z"
      />
    </svg>
  );
};

export const PlayIcon = () => {
  return (
    <svg
      style={{ margin: "0 auto" }}
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#464646" opacity="0" width="18" height="18" />
      <path
        fill="#464646"
        d="M4.73,2H3.5a.5.5,0,0,0-.5.5v13a.5.5,0,0,0,.5.5H4.73a1,1,0,0,0,.5035-.136l11.032-6.433a.5.5,0,0,0,0-.862L5.2335,2.136A1,1,0,0,0,4.73,2Z"
      />
    </svg>
  );
};

export const PauseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      style={{ margin: "0 auto" }}
    >
      <rect id="Canvas" fill="#464646" opacity="0" width="18" height="18" />
      <rect fill="#464646" height="14" rx="0.5" width="4" x="3" y="2" />
      <rect fill="#464646" height="14" rx="0.5" width="4" x="10" y="2" />
    </svg>
  );
};

export const MuteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.733"
      height="16.2"
      viewBox="0 0 15.733 16.2"
    >
      <path
        id="Path_26469"
        data-name="Path 26469"
        d="M123.045-834.032a.54.54,0,0,1-.32-.331.621.621,0,0,1,.029-.466q.087-.208.158-.432a3.071,3.071,0,0,0,.108-.453.765.765,0,0,1,.225-.424.594.594,0,0,1,.431-.181.514.514,0,0,1,.408.188.523.523,0,0,1,.133.418q-.05.346-.122.7a2.715,2.715,0,0,1-.237.686.535.535,0,0,1-.338.32A.668.668,0,0,1,123.045-834.032ZM118.679-838.651Zm.068-5.349a2.181,2.181,0,0,1,1.6.656,2.181,2.181,0,0,1,.656,1.6v3.954a.531.531,0,0,1-.183.44.629.629,0,0,1-.4.147.632.632,0,0,1-.4-.148.52.52,0,0,1-.185-.431v-3.962a1.049,1.049,0,0,0-.312-.773,1.049,1.049,0,0,0-.773-.312,1.049,1.049,0,0,0-.773.312,1.049,1.049,0,0,0-.312.773v.593a.531.531,0,0,1-.183.441.63.63,0,0,1-.4.147.632.632,0,0,1-.4-.148.519.519,0,0,1-.185-.43v-.6a2.181,2.181,0,0,1,.656-1.6A2.181,2.181,0,0,1,118.747-844Zm-.587,15v-1.849a5.374,5.374,0,0,1-3.3-1.565,5.269,5.269,0,0,1-1.576-3.3.5.5,0,0,1,.125-.431.527.527,0,0,1,.408-.179.569.569,0,0,1,.418.171.763.763,0,0,1,.214.424,4.175,4.175,0,0,0,1.455,2.685,4.232,4.232,0,0,0,2.841,1.057,3.747,3.747,0,0,0,1.64-.368,4.938,4.938,0,0,0,1.381-.986l.853.853a6.053,6.053,0,0,1-1.506,1.1,4.917,4.917,0,0,1-1.78.533V-829a.57.57,0,0,1-.168.418.562.562,0,0,1-.415.169.577.577,0,0,1-.42-.169A.563.563,0,0,1,118.16-829Zm7.068.8-14.309-14.309a.583.583,0,0,1-.192-.4.566.566,0,0,1,.192-.413.589.589,0,0,1,.42-.2.589.589,0,0,1,.42.2l14.309,14.309a.583.583,0,0,1,.192.4.566.566,0,0,1-.192.413.589.589,0,0,1-.42.2A.589.589,0,0,1,125.227-828.2Z"
        transform="translate(-110.626 844.1)"
        fill="#000"
        stroke="#000"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const UnMmuteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16.2"
      viewBox="0 0 16 16.2"
    >
      <g id="Group_72794" data-name="Group 72794" transform="translate(0 0.1)">
        <rect id="Canvas" width="16" height="16" fill="#222" opacity="0" />
        <path
          id="Path_26477"
          data-name="Path 26477"
          d="M243.549-833.8a2.238,2.238,0,0,1-1.645-.673,2.238,2.238,0,0,1-.673-1.645v-5.565a2.238,2.238,0,0,1,.673-1.645,2.238,2.238,0,0,1,1.645-.673,2.238,2.238,0,0,1,1.645.673,2.238,2.238,0,0,1,.673,1.645v5.565a2.238,2.238,0,0,1-.673,1.645A2.238,2.238,0,0,1,243.549-833.8ZM243.549-838.9Zm-.6,10.3v-1.9a5.405,5.405,0,0,1-3.387-1.6,5.452,5.452,0,0,1-1.616-3.392.517.517,0,0,1,.129-.442.542.542,0,0,1,.419-.184.576.576,0,0,1,.429.181.8.8,0,0,1,.22.431,4.279,4.279,0,0,0,1.489,2.76,4.336,4.336,0,0,0,2.91,1.08,4.335,4.335,0,0,0,2.931-1.092,4.309,4.309,0,0,0,1.488-2.749.811.811,0,0,1,.214-.431.564.564,0,0,1,.426-.181.552.552,0,0,1,.424.184.513.513,0,0,1,.132.442,5.433,5.433,0,0,1-1.616,3.387,5.456,5.456,0,0,1-3.387,1.6v1.9a.586.586,0,0,1-.172.43.576.576,0,0,1-.426.173.592.592,0,0,1-.431-.173A.577.577,0,0,1,242.946-828.6Zm.6-6.4a1.077,1.077,0,0,0,.793-.32,1.077,1.077,0,0,0,.32-.793v-5.565a1.077,1.077,0,0,0-.32-.793,1.077,1.077,0,0,0-.793-.32,1.077,1.077,0,0,0-.793.32,1.077,1.077,0,0,0-.32.793v5.565a1.077,1.077,0,0,0,.32.793A1.077,1.077,0,0,0,243.549-835Z"
          transform="translate(-235.549 844)"
          stroke="#000"
          strokeWidth="0.2"
        />
      </g>
    </svg>
  );
};

export const VolumeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      style={{ margin: "0 auto" }}
    >
      <rect id="Canvas" fill="#ffffff" opacity="0" width="18" height="18" />
      <path
        fill="#ffffff"
        d="M3.3725,6.0365H.5a.5.5,0,0,0-.5.5V11.5a.5.5,0,0,0,.5.5H3.3725a.714.714,0,0,1,.4655.1725L7.403,15.802A.3635.3635,0,0,0,8,15.5145V2.5a.363.363,0,0,0-.597-.2855l-3.5635,3.65A.72.72,0,0,1,3.3725,6.0365Z"
      />
      <path
        fill="#ffffff"
        d="M11.02,9a3.46751,3.46751,0,0,1-.7035,2.096.49.49,0,0,0,.043.644l.008.008a.496.496,0,0,0,.7435-.045A4.47751,4.47751,0,0,0,11.1,6.2765a.496.496,0,0,0-.742-.0435l-.0075.008a.491.491,0,0,0-.0425.646A3.47151,3.47151,0,0,1,11.02,9Z"
      />
      <path
        fill="#ffffff"
        d="M14.02,9a6.469,6.469,0,0,1-1.5575,4.2175.4865.4865,0,0,0,.0315.6585l.007.007a.5.5,0,0,0,.70711-.00167q.01566-.01574.02989-.03283a7.49,7.49,0,0,0-.013-9.7145.5.5,0,0,0-.70443-.0614q-.01558.01308-.03007.0274l-.007.0075a.48849.48849,0,0,0-.0335.6595A6.46848,6.46848,0,0,1,14.02,9Z"
      />
    </svg>
  );
};
export const CallHangupIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.58"
      height="5.948"
      viewBox="0 0 16.58 5.948"
      style={{ margin: "0 auto" }}
    >
      <path
        id="Icon_map-volume-control-telephone"
        // dataName="Icon map-volume-control-telephone"
        d="M4.248,4.685H5.388c.342,0,.56-.5.56-.841V.257c0-.339-.218-.245-.56-.245H4.248Zm0,6.8H5.388c.342,0,.56.394.56.734V15.8c0,.337-.218.777-.56.777H4.248Zm-1.5-3.4c-.01-3.278.607-3.4.958-3.4h.121V.012H3.678C3.052.012,0,1.041,0,8.3S3.052,16.58,3.678,16.58h.145v-5.1H3.7C3.351,11.482,2.754,11.361,2.744,8.084Z"
        transform="translate(16.58) rotate(90)"
        fill="#fff"
      />
    </svg>
  );
};

export const MaximizeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        // class="a"
        d="M7.0385,10.3535a.5.5,0,0,0-.707,0l-3.242,3.242L1.6,12.103A.344.344,0,0,0,1.3525,12a.35.35,0,0,0-.35.35v4.42a.25.25,0,0,0,.227.23H5.65A.35.35,0,0,0,6,16.65a.34252.34252,0,0,0-.1035-.245l-1.492-1.4945,3.242-3.242a.5.5,0,0,0,0-.707Z"
        fill="#ffffff"
      />
      <path
        // class="a"
        d="M16.7705,1H12.35a.35.35,0,0,0-.35.35V1.3525a.34253.34253,0,0,0,.1035.245l1.492,1.492-3.242,3.242a.5.5,0,0,0,0,.707l.608.608a.5.5,0,0,0,.707,0l3.242-3.242,1.492,1.4925A.344.344,0,0,0,16.65,6,.35.35,0,0,0,17,5.65h0V1.2295A.25.25,0,0,0,16.7705,1Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      style={{ margin: "0 auto" }}
    >
      <rect id="Canvas" fill="#ffffff" opacity="0" width="18" height="18" />
      <path
        fill="#ffffff"
        d="M13.2425,3.343,9,7.586,4.7575,3.343a.5.5,0,0,0-.707,0L3.343,4.05a.5.5,0,0,0,0,.707L7.586,9,3.343,13.2425a.5.5,0,0,0,0,.707l.707.7075a.5.5,0,0,0,.707,0L9,10.414l4.2425,4.243a.5.5,0,0,0,.707,0l.7075-.707a.5.5,0,0,0,0-.707L10.414,9l4.243-4.2425a.5.5,0,0,0,0-.707L13.95,3.343a.5.5,0,0,0-.70711-.00039Z"
      />
    </svg>
  );
};

export const CallTransferIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      style={{ margin: "0 auto" }}
    >
      <defs>
        <clipPath id="clipPath">
          <rect width="16" height="16" fill="none" />
        </clipPath>
      </defs>
      <g
        id="Repeat_Grid_4808"
        // dataName="Repeat Grid 4808"
        clipPath="url(#clipPath)"
      >
        <g transform="translate(-1662 -895)">
          <circle
            id="Ellipse_9633"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1656 -895)">
          <circle
            id="Ellipse_9633-2"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1650 -895)">
          <circle
            id="Ellipse_9633-3"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1662 -889)">
          <circle
            id="Ellipse_9633-4"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1656 -889)">
          <circle
            id="Ellipse_9633-5"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1650 -889)">
          <circle
            id="Ellipse_9633-6"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1662 -883)">
          <circle
            id="Ellipse_9633-7"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1656 -883)">
          <circle
            id="Ellipse_9633-8"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
        <g transform="translate(-1650 -883)">
          <circle
            id="Ellipse_9633-9"
            // dataName="Ellipse 9633"
            cx="2"
            cy="2"
            r="2"
            transform="translate(1662 895)"
            fill="#464646"
          />
        </g>
      </g>
    </svg>
  );
};

export const UpArrowIcon = () => {
  return (
    <svg
      id="Action_button"
      data-name="Action button"
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <g
        id="Placement_Area"
        data-name="Placement Area"
        fill="red"
        stroke="rgba(0,0,0,0)"
        strokeWidth="1"
        opacity="0"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <rect
        id="Background"
        width="40"
        height="40"
        rx="4"
        fill="rgba(255,0,0,0)"
      />
      <g id="Icon" transform="translate(10 10)">
        <g id="Canvas" fill="#fff" stroke="#a2a2a2" strokeWidth="1" opacity="0">
          <rect width="20" height="20" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
        </g>
        <path
          id="Path_83677"
          data-name="Path 83677"
          d="M15.107,11.544a1.111,1.111,0,0,1-1.895.784L9.558,8.677,5.9,12.328a1.111,1.111,0,0,1-1.6-1.541l.027-.027,4.44-4.436a1.111,1.111,0,0,1,1.569,0l4.438,4.435a1.1,1.1,0,0,1,.326.784Z"
          transform="translate(0.449 0.667)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
export const UpArrowRedIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      style={{
        background: props.background,
        borderRadius: "2px 2px 0px 0px",
      }}
    >
      <rect id="Canvas" fill="red" opacity="0" width="20" height="20" />
      <path
        fill={props.color}
        d="M14,10.99a1,1,0,0,1-1.7055.7055l-3.289-3.286-3.289,3.286a1,1,0,0,1-1.437-1.3865l.0245-.0245L8.3,6.2925a1,1,0,0,1,1.4125,0L13.707,10.284A.9945.9945,0,0,1,14,10.99Z"
      />
    </svg>
  );
};
export const DownArrowRedIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 20 20"
      width="20"
      style={{
        background: props.background,
        borderRadius: "2px 2px 0px 0px",
      }}
    >
      <rect
        id="Canvas"
        fill={props.background}
        opacity="0"
        width="20"
        height="20"
      />
      <path
        fill={props.color}
        d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z"
      />
    </svg>
  );
};
export const BackArrowIcon = () => {
  return (
    <svg
      id="Group_2"
      data-name="Group 2"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="10"
      viewBox="0 0 14 10"
    >
      <rect id="ToDelete" width="14" height="10" fill="#ff13dc" opacity="0" />
      <path
        id="Path_3"
        data-name="Path 3"
        d="M12.99,4H3.414L5.7,1.717A1,1,0,1,0,4.283.3L.3,4.293a1,1,0,0,0,0,1.415L4.283,9.7A1,1,0,1,0,5.7,8.283L3.414,6H12.99a1,1,0,0,0,0-2Z"
        fill="#6e6e6e"
      />
    </svg>
  );
};

export const ChevronRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        fill="#6E6E6E"
        d="M12,9a.994.994,0,0,1-.2925.7045l-3.9915,3.99a1,1,0,1,1-1.4355-1.386l.0245-.0245L9.5905,9,6.3045,5.715A1,1,0,0,1,7.691,4.28l.0245.0245,3.9915,3.99A.994.994,0,0,1,12,9Z"
      />
    </svg>
  );
};

export const ChevronLeft = ({ fill }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      fill={fill}
    >
      <rect
        id="Canvas"
        fill={fill || "#ff13dc"}
        opacity="0"
        width="18"
        height="18"
      />
      <path
        className="fill"
        d="M6,9a.994.994,0,0,0,.2925.7045l3.9915,3.99a1,1,0,1,0,1.4355-1.386l-.0245-.0245L8.4095,9l3.286-3.285A1,1,0,0,0,10.309,4.28l-.0245.0245L6.293,8.2945A.994.994,0,0,0,6,9Z"
      />
    </svg>
  );
};

export const UserGroup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        fill="#6E6E6E"
        d="M13.461,10.238c-.7205-.0625-.732-.642-.732-1.3645A6.57549,6.57549,0,0,0,14.274,4.955C14.274,2.582,12.924,1,10.9795,1A3.15,3.15,0,0,0,9.64,1.287a5.34543,5.34543,0,0,1,2.62,4.95,7.80009,7.80009,0,0,1-1.21,3.9745.43051.43051,0,0,0,.237.644A6.744,6.744,0,0,1,15.8895,15H17.518a.4355.4355,0,0,0,.44022-.43072q.00016-.01515-.00072-.03028C17.668,11.3945,14.446,10.324,13.461,10.238Z"
      />
      <path
        fill="#6E6E6E"
        d="M14.4865,17a.46551.46551,0,0,0,.47134-.45959q.00021-.01721-.00084-.03441c-.31-3.367-3.7625-4.514-4.818-4.606-.772-.067-.7845-.6885-.7845-1.4625a7.04646,7.04646,0,0,0,1.6555-4.2C11.01,3.6955,9.563,2,7.4795,2S3.95,3.6955,3.95,6.2385a7.04646,7.04646,0,0,0,1.6555,4.2c0,.774-.0125,1.3955-.7845,1.4625C3.7645,11.992.312,13.139,0,16.506a.4655.4655,0,0,0,.43606.49319Q.45426,17.00032.4725,17Z"
      />
    </svg>
  );
};

export const CheckboxCheked = () => {
  return (
    <svg
      id="Checkbox"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="32"
      viewBox="0 0 14 32"
    >
      <g
        id="Placement_Area"
        data-name="Placement Area"
        fill="red"
        stroke="rgba(0,0,0,0)"
        strokeWidth="1"
        opacity="0"
      >
        <rect width="14" height="32" stroke="none" />
        <rect x="0.5" y="0.5" width="13" height="31" fill="none" />
      </g>
      <g
        id="Box"
        transform="translate(0 9)"
        fill="#1473e6"
        stroke="rgba(0,0,0,0)"
        strokeWidth="1"
      >
        <rect width="14" height="14" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" fill="none" />
      </g>
      <g id="Checkmark">
        <g
          id="Frame"
          transform="translate(2 11)"
          fill="#f0f"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="10" height="10" stroke="none" />
          <rect x="0.5" y="0.5" width="9" height="9" fill="none" />
        </g>
        <path
          id="Shape"
          d="M3.788,9A1,1,0,0,1,3,8.615l-2.288-3a1,1,0,1,1,1.576-1.23l1.5,1.991L7.712,1.385a1,1,0,1,1,1.576,1.23l-4.712,6A1,1,0,0,1,3.788,9Z"
          transform="translate(2 11)"
          fill="#fafafa"
        />
      </g>
    </svg>
  );
};

export const CheckboxUnCheked = () => {
  return (
    <svg
      id="Checkbox"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="32"
      viewBox="0 0 14 32"
    >
      <g
        id="Placement_Area"
        data-name="Placement Area"
        fill="red"
        stroke="rgba(0,0,0,0)"
        strokeWidth="1"
        opacity="0"
      >
        <rect width="14" height="32" stroke="none" />
        <rect x="0.5" y="0.5" width="13" height="31" fill="none" />
      </g>
      <g
        id="Box"
        transform="translate(0 9)"
        fill="#fafafa"
        stroke="#8e8e8e"
        strokeWidth="2"
      >
        <rect width="14" height="14" rx="2" stroke="none" />
        <rect x="1" y="1" width="12" height="12" rx="1" fill="none" />
      </g>
    </svg>
  );
};

export const ChevronDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="18"
    viewBox="0 0 18 18"
    width="18"
  >
    <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
    <path
      fill="#6E6E6E"
      d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z"
    />
  </svg>
);

export const CallCenter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="18"
    viewBox="0 0 18 18"
    width="18"
  >
    <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
    <path
      fill="#6E6E6E"
      d="M15.5455,7H14.818A5.9115,5.9115,0,0,0,9,1,5.9115,5.9115,0,0,0,3.182,7H2.4545A1.478,1.478,0,0,0,1,8.5v3A1.478,1.478,0,0,0,2.4545,13h2.182V7H4.6A4.47051,4.47051,0,0,1,9,2.4625,4.47051,4.47051,0,0,1,13.4,7h-.0365v5.669a5.09151,5.09151,0,0,1-3.1055,2.4A1.55753,1.55753,0,0,0,9,14.5a1.32171,1.32171,0,0,0-1.4545,1.125A1.32171,1.32171,0,0,0,9,16.75a1.394,1.394,0,0,0,1.4295-.9345A5.841,5.841,0,0,0,14.0275,13h1.518A1.478,1.478,0,0,0,17,11.5v-3A1.478,1.478,0,0,0,15.5455,7Z"
    />
  </svg>
);

export const NotReady = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="69.147"
      height="69.147"
      viewBox="0 0 69.147 69.147"
    >
      <g
        id="Group_160945"
        data-name="Group 160945"
        transform="translate(-896.602 -183)"
      >
        <line
          id="Line_34"
          data-name="Line 34"
          x2="67"
          transform="translate(897.602 251.147)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <rect
          id="Rectangle_150549"
          data-name="Rectangle 150549"
          width="14"
          height="15"
          rx="7"
          transform="translate(903.602 208.147)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83098"
          data-name="Path 83098"
          d="M904.1,367.826a6.5,6.5,0,0,1-6.5-6.5v-8.664A8.662,8.662,0,0,1,906.266,344h8.664a8.671,8.671,0,0,1,8.393,6.5"
          transform="translate(0 -116.679)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83099"
          data-name="Path 83099"
          d="M993.428,385.328H969.6L971.768,368h23.827Z"
          transform="translate(-52.506 -134.181)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83100"
          data-name="Path 83100"
          d="M921.6,384v6.5a2.166,2.166,0,0,0,2.166,2.166h8.664A4.332,4.332,0,0,1,928.1,397h-6.5"
          transform="translate(-17.502 -145.849)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <ellipse
          id="Ellipse_9613"
          data-name="Ellipse 9613"
          cx="2"
          cy="2.5"
          rx="2"
          ry="2.5"
          transform="translate(927.602 240.147)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <g
          id="Group_160943"
          data-name="Group 160943"
          transform="translate(911.681 184)"
        >
          <path
            id="Path_83101"
            data-name="Path 83101"
            d="M985.342,236.332a27.074,27.074,0,1,0-35.74-32.837"
            transform="translate(-949.602 -184)"
            fill="none"
            stroke="#7c7c7c"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_83102"
            data-name="Path 83102"
            d="M1045.6,216v18.411l9.747,9.747"
            transform="translate(-1019.609 -207.336)"
            fill="none"
            stroke="#7c7c7c"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
        <g
          id="Group_160944"
          data-name="Group 160944"
          transform="translate(948.504 242.552)"
        >
          <path
            id="Rectangle_150550"
            data-name="Rectangle 150550"
            d="M0,0H9A0,0,0,0,1,9,0V4.5A4.5,4.5,0,0,1,4.5,9h0A4.5,4.5,0,0,1,0,4.5V0A0,0,0,0,1,0,0Z"
            transform="translate(3.098 -0.405)"
            fill="none"
            stroke="#7c7c7c"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_83103"
            data-name="Path 83103"
            d="M1088.851,410.5a3.249,3.249,0,0,1,0-6.5"
            transform="translate(-1085.602 -402.985)"
            fill="none"
            stroke="#7c7c7c"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export const Ready = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="87.137"
      height="61.317"
      viewBox="0 0 87.137 61.317"
    >
      <g
        id="Group_160942"
        data-name="Group 160942"
        transform="translate(-1964.602 -1274.911)"
      >
        <line
          id="Line_32"
          data-name="Line 32"
          x2="74.197"
          transform="translate(1965.602 1335.229)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <rect
          id="Rectangle_150546"
          data-name="Rectangle 150546"
          width="17.458"
          height="19.64"
          rx="8.729"
          transform="translate(1978.695 1280.672)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83091"
          data-name="Path 83091"
          d="M2014.558,1436.717v-13.732A10.986,10.986,0,0,0,2003.573,1412h-10.985a10.985,10.985,0,0,0-10.985,10.985v10.985a8.239,8.239,0,0,0,8.239,8.239"
          transform="translate(-10.508 -107.252)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83092"
          data-name="Path 83092"
          d="M2110.558,1410.21h10.985l2.746-30.21h-43.942l-2.746,30.21h13.731"
          transform="translate(-73.551 -86.237)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83093"
          data-name="Path 83093"
          d="M2005.6,1452v8.239a2.746,2.746,0,0,0,2.747,2.746h10.985a5.493,5.493,0,0,1-5.493,5.493H2005.6"
          transform="translate(-26.268 -133.52)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <ellipse
          id="Ellipse_9609"
          data-name="Ellipse 9609"
          cx="2.728"
          cy="2.182"
          rx="2.728"
          ry="2.182"
          transform="translate(2024.523 1302.495)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83094"
          data-name="Path 83094"
          d="M2132.587,1436l2.746,19.224-2.746,2.747H2121.6l4.12-4.12,1.373-17.851Z"
          transform="translate(-102.446 -123.013)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Rectangle_150547"
          data-name="Rectangle 150547"
          d="M3.273,0h0a0,0,0,0,1,0,0V6.547a0,0,0,0,1,0,0h0A3.273,3.273,0,0,1,0,3.273v0A3.273,3.273,0,0,1,3.273,0Z"
          transform="translate(1972.148 1287.219)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Rectangle_150548"
          data-name="Rectangle 150548"
          d="M3.273,0H5.456a0,0,0,0,1,0,0V6.547a0,0,0,0,1,0,0H3.273A3.273,3.273,0,0,1,0,3.273v0A3.273,3.273,0,0,1,3.273,0Z"
          transform="translate(2004.882 1293.766) rotate(-180)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_83095"
          data-name="Path 83095"
          d="M1993.6,1340.359a12.359,12.359,0,0,1,24.718,0"
          transform="translate(-18.388 -52.089)"
          fill="none"
          stroke="#7c7c7c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export const Alert = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#FF13DC" opacity="0" width="18" height="18" />
      <path
        fill="#D7373F"
        d="M8.5635,1.2895.2,16.256A.5.5,0,0,0,.636,17H17.364a.5.5,0,0,0,.436-.744L9.4365,1.2895a.5.5,0,0,0-.873,0ZM10,14.75a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,14.75v-1.5A.25.25,0,0,1,8.25,13h1.5a.25.25,0,0,1,.25.25Zm0-3a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,11.75v-6a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25Z"
      />
    </svg>
  );
};
export const AlertWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <rect id="Canvas" fill="#FF13DC" opacity="0" width="24" height="24" />
      <path
        fill="#FFFFFF"
        d="M8.5635,1.2895.2,16.256A.5.5,0,0,0,.636,17H17.364a.5.5,0,0,0,.436-.744L9.4365,1.2895a.5.5,0,0,0-.873,0ZM10,14.75a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,14.75v-1.5A.25.25,0,0,1,8.25,13h1.5a.25.25,0,0,1,.25.25Zm0-3a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,11.75v-6a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25Z"
      />
    </svg>
  );
};

export const CheveronUpDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        // class="a"
        d="M14,5.99a1,1,0,0,1-1.7055.7055L9.006,3.409,5.717,6.695A1,1,0,0,1,4.28,5.3085l.0245-.0245L8.3,1.2925a1,1,0,0,1,1.4125,0L13.707,5.284A.99446.99446,0,0,1,14,5.99Z"
      />
      <path
        // class="a"
        d="M4,12.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,16.707a1,1,0,0,1-1.4125,0L4.293,12.7155A.99452.99452,0,0,1,4,12.01Z"
      />
    </svg>
  );
};

export const Send = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#2C2C2C" opacity="0" width="18" height="18" />
      <path
        // class="a"
        d="M16.5955,2.5565.9,7.239a.25.25,0,0,0-.0405.4635L4.82,9.679Z"
      />
      <path
        // class="a"
        d="M6.5445,10.516l5.9685,3a.5.5,0,0,0,.67121-.22243l.00029-.00057L17.818,3.182Z"
      />
      <path
        // class="a"
        d="M5.04,11.625v3.8195a.3565.3565,0,0,0,.587.272l2.68-2.258Z"
      />
    </svg>
  );
};

export const Book = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#2C2C2C" opacity="0" width="18" height="18" />
      <path
        // class="a"
        d="M9.891,14H4.9975a2,2,0,1,1,0-4H10.259a.5.5,0,0,0,.4-.2l5.55-7.4a.25.25,0,0,0-.2-.4H8.0125a.5.5,0,0,0-.4.2L1.761,9.664A3.9905,3.9905,0,0,0,4.9845,16H10.259a.5.5,0,0,0,.4-.2l5.55-7.4a.25.25,0,0,0-.2-.4H14.391Z"
      />
    </svg>
  );
};

export const ChatRinging = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        // class="a"
        d="M3.3725,6.0365H.5a.5.5,0,0,0-.5.5V11.5a.5.5,0,0,0,.5.5H3.3725a.714.714,0,0,1,.4655.1725L7.403,15.802A.3635.3635,0,0,0,8,15.5145V2.5a.363.363,0,0,0-.597-.2855l-3.5635,3.65A.72.72,0,0,1,3.3725,6.0365Z"
      />
      <path
        // class="a"
        d="M11.02,9a3.46751,3.46751,0,0,1-.7035,2.096.49.49,0,0,0,.043.644l.008.008a.496.496,0,0,0,.7435-.045A4.47751,4.47751,0,0,0,11.1,6.2765a.496.496,0,0,0-.742-.0435l-.0075.008a.491.491,0,0,0-.0425.646A3.47151,3.47151,0,0,1,11.02,9Z"
      />
      <path
        // class="a"
        d="M14.02,9a6.469,6.469,0,0,1-1.5575,4.2175.4865.4865,0,0,0,.0315.6585l.007.007a.5.5,0,0,0,.70711-.00167q.01566-.01574.02989-.03283a7.49,7.49,0,0,0-.013-9.7145.5.5,0,0,0-.70443-.0614q-.01558.01308-.03007.0274l-.007.0075a.48849.48849,0,0,0-.0335.6595A6.46848,6.46848,0,0,1,14.02,9Z"
      />
    </svg>
  );
};

export const Circle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <circle className="a" cx="9" cy="9" r="8" />
    </svg>
  );
};

export const File = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        className="fill"
        d="M8.1035,15.7785a3.32,3.32,0,0,1-2.364.985h-.053A3.488,3.488,0,0,1,3.273,15.726a3.382,3.382,0,0,1-.09763-4.78187L3.223,10.8955l8.8895-8.9A2.437,2.437,0,0,1,13.679,1.256a1.86,1.86,0,0,1,1.521.56,1.76853,1.76853,0,0,1,.5585,1.534,2.87,2.87,0,0,1-.792,1.5L9.036,10.7705c-.382.3825-.7415.6575-1.15.25s-.088-.7845.263-1.1355c.1335-.1335,4.124-4.119,4.8365-4.8295a.366.366,0,0,0,.007-.5105l-.3375-.359a.3675.3675,0,0,0-.51948-.01578L12.127,4.1785,7.15,9.172a1.816,1.816,0,0,0-.036,2.7345c1.3305,1.33,2.8415-.2955,2.8415-.2955L15.85,5.733a3.30462,3.30462,0,0,0,.236-4.8A3.1135,3.1135,0,0,0,13.7945,0a3.6375,3.6375,0,0,0-2.566,1.1135L2.38,9.95a4.7165,4.7165,0,0,0,6.67,6.67l7.7025-7.7a.36749.36749,0,0,0,0-.519l-.375-.3755a.3675.3675,0,0,0-.5195,0Z"
      />
    </svg>
  );
};

export const CloseIconBlack = ({ title = "Close" }: { title?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="14"
      viewBox="0 0 18 18"
      width="14"
    >
      <defs></defs>
      <title>{title}</title>
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        className="fill"
        d="M13.2425,3.343,9,7.586,4.7575,3.343a.5.5,0,0,0-.707,0L3.343,4.05a.5.5,0,0,0,0,.707L7.586,9,3.343,13.2425a.5.5,0,0,0,0,.707l.707.7075a.5.5,0,0,0,.707,0L9,10.414l4.2425,4.243a.5.5,0,0,0,.707,0l.7075-.707a.5.5,0,0,0,0-.707L10.414,9l4.243-4.2425a.5.5,0,0,0,0-.707L13.95,3.343a.5.5,0,0,0-.70711-.00039Z"
      />
    </svg>
  );
};

export const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Decorative_icon"
        data-name="Decorative icon"
        transform="translate(0)"
      >
        <rect
          id="Placement_Area"
          data-name="Placement Area"
          width="48"
          height="48"
          transform="translate(0)"
          fill="red"
          opacity="0"
        />
        <g id="Icon" transform="translate(0)">
          <rect id="Canvas" width="48" height="48" fill="#747474" opacity="0" />
          <path
            id="Path_12990"
            data-name="Path 12990"
            d="M46.5,1H1.5A1.529,1.529,0,0,0,0,2.556V36.777a1.529,1.529,0,0,0,1.5,1.556H21.212a15.216,15.216,0,0,1-.479-2.667H2.667V32.477L17.553,21.333,22.4,24.966a2.623,2.623,0,0,0,1.136.459,15.313,15.313,0,0,1,9.629-6.159l12.168-9.153V22.186A15.414,15.414,0,0,1,48,24.8V2.556A1.529,1.529,0,0,0,46.5,1ZM2.667,29.142V10.175l12.667,9.492ZM24,22.833,2.667,6.84V3.667H45.333V6.779Z"
            transform="translate(0 1.667)"
            fill="#747474"
          />
          <path
            id="Path_12991"
            data-name="Path 12991"
            d="M20.917,9.05A11.867,11.867,0,1,0,32.783,20.917,11.867,11.867,0,0,0,20.917,9.05Zm0,21.2a9.288,9.288,0,0,1-7.367-15L26.586,28.283A9.246,9.246,0,0,1,20.917,30.25Zm7.367-3.664L15.247,13.55A9.288,9.288,0,0,1,28.283,26.586Z"
            transform="translate(15.083 15.083)"
            fill="#747474"
          />
        </g>
      </g>
    </svg>
  );
};

export const HeadphoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <defs></defs>
      <title>S CallCenter 18 N</title>
      <rect id="Canvas" fill="#222222" opacity="0" width="18" height="18" />
      <path
        className="fill"
        d="M15.5455,7H14.818A5.9115,5.9115,0,0,0,9,1,5.9115,5.9115,0,0,0,3.182,7H2.4545A1.478,1.478,0,0,0,1,8.5v3A1.478,1.478,0,0,0,2.4545,13h2.182V7H4.6A4.47051,4.47051,0,0,1,9,2.4625,4.47051,4.47051,0,0,1,13.4,7h-.0365v5.669a5.09151,5.09151,0,0,1-3.1055,2.4A1.55753,1.55753,0,0,0,9,14.5a1.32171,1.32171,0,0,0-1.4545,1.125A1.32171,1.32171,0,0,0,9,16.75a1.394,1.394,0,0,0,1.4295-.9345A5.841,5.841,0,0,0,14.0275,13h1.518A1.478,1.478,0,0,0,17,11.5v-3A1.478,1.478,0,0,0,15.5455,7Z"
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <defs></defs>
      <title>S RealTimeCustomerProfile 18 N</title>
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        className="fill"
        d="M9,.5A8.5,8.5,0,1,0,17.5,9,8.5,8.5,0,0,0,9,.5Zm5.491,13.59161a5.41289,5.41289,0,0,0-3.11213-1.56415.65361.65361,0,0,1-.5655-.65569V10.9256a.65656.65656,0,0,1,.16645-.42218A4.99536,4.99536,0,0,0,12.12006,7.3855c0-2.36029-1.25416-3.67963-3.14337-3.67963s-3.179,1.36835-3.179,3.67963A5.05147,5.05147,0,0,0,6.9892,10.5047a.655.655,0,0,1,.16656.42206v.94165a.64978.64978,0,0,1-.57006.65539,5.43158,5.43158,0,0,0-3.11963,1.5205,7.49965,7.49965,0,1,1,11.025.04731Z"
      />
    </svg>
  );
};

export const WarningIcon = () => {
  return (
    <svg
      id="Decorative_icon"
      data-name="Decorative icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="18"
        height="18"
        fill="red"
        opacity="0"
      />
      <g id="Icon">
        <rect id="Canvas" width="18" height="18" fill="#747474" opacity="0" />
        <path
          id="Path_12984"
          data-name="Path 12984"
          d="M9,1a8,8,0,1,0,8,8A8,8,0,0,0,9,1ZM7.7,3.388a.356.356,0,0,1,.169-.338,3.123,3.123,0,0,1,1.112-.229,3.431,3.431,0,0,1,1.116.172.388.388,0,0,1,.2.343V4.562c0,1.443-.288,5.445-.342,5.973a.264.264,0,0,1-.265.262l-.028,0H8.3a.284.284,0,0,1-.289-.236c-.05-.682-.311-4.55-.311-5.945ZM9,14.425a1.287,1.287,0,0,1-1.4-1.316,1.33,1.33,0,0,1,1.308-1.352q.046,0,.092,0a1.316,1.316,0,0,1,1.4,1.229q0,.061,0,.121A1.287,1.287,0,0,1,9,14.425Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const CallIcon = ({ fill = "#464646" }) => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14.3"
      height="14.3"
      viewBox="0 0 14.3 14.3"
    >
      <path
        id="call_24dp_E8EAED_FILL0_wght200_GRAD0_opsz24"
        d="M173.064-786a10.5,10.5,0,0,1-4.536-1.108,15.527,15.527,0,0,1-4.318-3.111,15.77,15.77,0,0,1-3.1-4.318A10.447,10.447,0,0,1,160-799.064a.916.916,0,0,1,.263-.668.882.882,0,0,1,.656-.267h2.164a.935.935,0,0,1,.623.225,1.111,1.111,0,0,1,.36.576l.434,2.086a1.42,1.42,0,0,1-.022.641.917.917,0,0,1-.291.449l-1.92,1.79a13.8,13.8,0,0,0,1.19,1.817,18.072,18.072,0,0,0,1.391,1.589,15,15,0,0,0,1.641,1.418,17.029,17.029,0,0,0,1.928,1.238l1.871-1.9a1.019,1.019,0,0,1,.48-.3,1.469,1.469,0,0,1,.59-.03l1.841.377a1.048,1.048,0,0,1,.579.359.957.957,0,0,1,.222.623v2.13a.882.882,0,0,1-.267.656A.915.915,0,0,1,173.064-786Zm-11.208-9.053,1.679-1.545a.313.313,0,0,0,.109-.185.41.41,0,0,0-.009-.219l-.389-1.854a.36.36,0,0,0-.118-.2.34.34,0,0,0-.219-.067h-1.8a.228.228,0,0,0-.168.067.228.228,0,0,0-.067.168,8.3,8.3,0,0,0,.281,1.873A12.852,12.852,0,0,0,161.856-795.053Zm7.394,7.293a7.879,7.879,0,0,0,1.89.649,9.633,9.633,0,0,0,1.749.226.228.228,0,0,0,.168-.067.228.228,0,0,0,.067-.168v-1.757a.34.34,0,0,0-.067-.219.361.361,0,0,0-.2-.118l-1.619-.332a.277.277,0,0,0-.177-.008.427.427,0,0,0-.16.109ZM161.856-795.053ZM169.25-787.76Z"
        transform="translate(-159.85 800.15)"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
    </svg>
  );
};
export const CallIconWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <g id="Icon" transform="translate(-21)">
        <rect
          id="Frame"
          width="22"
          height="22"
          transform="translate(21)"
          fill="#fff"
          opacity="0"
        />
        <path
          id="call_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24_1_"
          data-name="call_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24 (1)"
          d="M136.95-822a15,15,0,0,1-6.175-1.363,18.468,18.468,0,0,1-5.55-3.862,18.465,18.465,0,0,1-3.862-5.55A15.008,15.008,0,0,1,120-838.951a1.018,1.018,0,0,1,.3-.75,1.019,1.019,0,0,1,.75-.3h4.05a.931.931,0,0,1,.625.237.915.915,0,0,1,.325.563l.65,3.5a1.764,1.764,0,0,1-.025.675,1.054,1.054,0,0,1-.275.476l-2.425,2.45a12.08,12.08,0,0,0,1.188,1.788,17.606,17.606,0,0,0,1.512,1.663,17.736,17.736,0,0,0,1.625,1.437A15.958,15.958,0,0,0,130.1-826l2.35-2.35a1.4,1.4,0,0,1,.588-.337,1.614,1.614,0,0,1,.712-.062l3.45.7a1.154,1.154,0,0,1,.575.363.88.88,0,0,1,.225.588v4.049a1.02,1.02,0,0,1-.3.751A1.019,1.019,0,0,1,136.95-822Zm-13.925-12,1.65-1.65L124.25-838h-2.225a20.54,20.54,0,0,0,.35,2.025A10.929,10.929,0,0,0,123.025-834Zm8.95,8.95a12.393,12.393,0,0,0,1.988.676,12.178,12.178,0,0,0,2.038.325v-2.2l-2.35-.475ZM123.025-834ZM131.975-825.051Z"
          transform="translate(-97 842)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const CallbackIcon = () => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14.3"
      height="14.3"
      viewBox="0 0 14.3 14.3"
    >
      <path
        id="phone_callback_24dp_E8EAED_FILL0_wght200_GRAD0_opsz24"
        d="M169.3-794.683h2.443a.423.423,0,0,1,.312.126.424.424,0,0,1,.126.312.422.422,0,0,1-.126.312.424.424,0,0,1-.312.125h-3.231a.684.684,0,0,1-.5-.2.684.684,0,0,1-.2-.5v-3.231a.423.423,0,0,1,.126-.312.424.424,0,0,1,.312-.126.422.422,0,0,1,.312.126.424.424,0,0,1,.125.312v2.443l4.469-4.469a.441.441,0,0,1,.3-.131.409.409,0,0,1,.318.131.43.43,0,0,1,.14.31.43.43,0,0,1-.14.31ZM173.064-786a10.5,10.5,0,0,1-4.536-1.108,15.527,15.527,0,0,1-4.318-3.111,15.77,15.77,0,0,1-3.1-4.318A10.447,10.447,0,0,1,160-799.064a.916.916,0,0,1,.263-.668.882.882,0,0,1,.656-.267h2.164a.935.935,0,0,1,.623.225,1.111,1.111,0,0,1,.36.576l.434,2.086a1.42,1.42,0,0,1-.022.641.917.917,0,0,1-.291.449l-1.92,1.79a13.8,13.8,0,0,0,1.19,1.817,18.072,18.072,0,0,0,1.391,1.589,15,15,0,0,0,1.641,1.418,17.029,17.029,0,0,0,1.928,1.238l1.871-1.9a1.019,1.019,0,0,1,.48-.3,1.469,1.469,0,0,1,.59-.03l1.841.377a1.048,1.048,0,0,1,.579.359.957.957,0,0,1,.222.623v2.13a.882.882,0,0,1-.267.656A.915.915,0,0,1,173.064-786Zm-11.208-9.053,1.679-1.545a.313.313,0,0,0,.109-.185.41.41,0,0,0-.009-.219l-.389-1.854a.36.36,0,0,0-.118-.2.34.34,0,0,0-.219-.067h-1.8a.228.228,0,0,0-.168.067.228.228,0,0,0-.067.168,8.3,8.3,0,0,0,.281,1.873A12.852,12.852,0,0,0,161.856-795.053Zm7.394,7.293a7.879,7.879,0,0,0,1.89.649,9.633,9.633,0,0,0,1.749.226.228.228,0,0,0,.168-.067.228.228,0,0,0,.067-.168v-1.757a.34.34,0,0,0-.067-.219.361.361,0,0,0-.2-.118l-1.619-.332a.277.277,0,0,0-.177-.008.427.427,0,0,0-.16.109ZM161.856-795.053ZM169.25-787.76Z"
        transform="translate(-159.85 800.15)"
        fill={"#000000"}
        stroke="#464646"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const VoicemailIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width="16.3"
      height="7.048"
      viewBox="0 0 16.3 7.048"
    >
      <path
        id="voicemail_24dp_E8EAED_FILL0_wght200_GRAD0_opsz24"
        d="M129.524-642.482a3.256,3.256,0,0,1-2.39-.983,3.248,3.248,0,0,1-.984-2.387,3.263,3.263,0,0,1,.983-2.391,3.243,3.243,0,0,1,2.387-.987,3.261,3.261,0,0,1,2.391.984,3.249,3.249,0,0,1,.987,2.39,3.417,3.417,0,0,1-.285,1.384,2.736,2.736,0,0,1-.845,1.085h4.765a2.736,2.736,0,0,1-.845-1.085,3.417,3.417,0,0,1-.285-1.384,3.256,3.256,0,0,1,.983-2.39,3.247,3.247,0,0,1,2.387-.984,3.263,3.263,0,0,1,2.391.983,3.243,3.243,0,0,1,.987,2.387,3.261,3.261,0,0,1-.984,2.391,3.248,3.248,0,0,1-2.39.987Zm0-.9a2.386,2.386,0,0,0,1.754-.716,2.383,2.383,0,0,0,.717-1.753,2.385,2.385,0,0,0-.716-1.754,2.383,2.383,0,0,0-1.753-.716,2.386,2.386,0,0,0-1.754.716,2.383,2.383,0,0,0-.717,1.753,2.386,2.386,0,0,0,.716,1.754A2.384,2.384,0,0,0,129.523-643.387Zm9.252,0a2.386,2.386,0,0,0,1.754-.716,2.383,2.383,0,0,0,.717-1.753,2.386,2.386,0,0,0-.716-1.754,2.384,2.384,0,0,0-1.753-.716,2.386,2.386,0,0,0-1.754.716,2.383,2.383,0,0,0-.717,1.753,2.385,2.385,0,0,0,.716,1.754A2.383,2.383,0,0,0,138.775-643.387Z"
        transform="translate(-126 649.38)"
        fill={color}
        stroke="#464646"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const ChatIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      id="Decorative_icon"
      data-name="Decorative icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="18"
        height="18"
        fill="red"
        opacity="0"
      />
      <g id="Icon">
        <rect id="Canvas" width="18" height="18" fill="#464646" opacity="0" />
        <path
          id="Path_12975"
          data-name="Path 12975"
          d="M9.5,7a.5.5,0,0,1,.5.5v6a.5.5,0,0,1-.5.5H4.793a.5.5,0,0,0-.353.146L3,15.585V14.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5v-6A.5.5,0,0,1,1.5,7Zm-8-1A1.5,1.5,0,0,0,0,7.5v6A1.5,1.5,0,0,0,1.5,15H2v2.4a.25.25,0,0,0,.427.177L5,15H9.5A1.5,1.5,0,0,0,11,13.5v-6A1.5,1.5,0,0,0,9.5,6Z"
          fill={color}
        />
        <path
          id="Path_12976"
          data-name="Path 12976"
          d="M12,7.3A2.3,2.3,0,0,0,9.7,5H6V2.5A1.5,1.5,0,0,1,7.5,1h9A1.5,1.5,0,0,1,18,2.5v6A1.5,1.5,0,0,1,16.5,10H15v2.4a.25.25,0,0,1-.427.177L12,10Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const CasesIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14.3"
      height="14"
      viewBox="0 0 14.3 14"
    >
      <g
        id="Decorative_icon"
        data-name="Decorative icon"
        transform="translate(0.15)"
      >
        <rect
          id="Placement_Area"
          data-name="Placement Area"
          width="14"
          height="14"
          fill="red"
          opacity="0"
        />
        <g id="Icon">
          <rect id="Canvas" width="14" height="14" fill="#747474" opacity="0" />
          <path
            id="Path_12989"
            data-name="Path 12989"
            d="M13.611,2H.389A.389.389,0,0,0,0,2.389V12.5a.389.389,0,0,0,.389.389H13.611A.389.389,0,0,0,14,12.5V2.389A.389.389,0,0,0,13.611,2Zm-.389.778v.586L7,8.121.778,3.363V2.778Zm0,1.564v6.183L9.178,7.434Zm-8.4,3.092L.778,10.526V4.342ZM.778,12.111V11.5L5.461,7.924l1.067.817a.778.778,0,0,0,.945,0l1.067-.817L13.222,11.5v.607Z"
            transform="translate(0 -0.444)"
            fill={color}
            stroke="#464646"
            strokeWidth="0.3"
          />
        </g>
      </g>
    </svg>
  );
};

export const HistoryIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      id="Decorative_icon"
      data-name="Decorative icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="16"
        height="16"
        transform="translate(0)"
        fill="red"
        opacity="0"
      />
      <g id="Icon" transform="translate(0)">
        <rect
          id="Canvas"
          width="16"
          height="16"
          transform="translate(0)"
          fill={color}
          opacity="0"
        />
        <path
          id="Path_12982"
          data-name="Path 12982"
          d="M9.333,3H8.444A.444.444,0,0,0,8,3.444v4.7a.444.444,0,0,0,.13.314l2.492,2.492a.444.444,0,0,0,.628,0l.594-.594a.444.444,0,0,0,0-.628L9.778,7.667V3.444A.444.444,0,0,0,9.333,3Z"
          transform="translate(-0.889 -0.333)"
          fill={color}
        />
        <path
          id="Path_12983"
          data-name="Path 12983"
          d="M8,1A7.087,7.087,0,0,0,3.047,3.008,5.833,5.833,0,0,0,1.265,6.333H.222A.222.222,0,0,0,0,6.556a.218.218,0,0,0,.065.156L1.637,8.5a.222.222,0,0,0,.281,0L3.49,6.711a.218.218,0,0,0,.065-.156.222.222,0,0,0-.222-.222H2.208A5.2,5.2,0,0,1,3.759,3.558a6.222,6.222,0,1,1,0,9.1.222.222,0,0,0-.307,0l-.314.314a.225.225,0,0,0,0,.318l0,0A7.111,7.111,0,1,0,8,1Z"
          transform="translate(0 -0.111)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const SearchIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      id="Decorative_icon"
      data-name="Decorative icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="16"
        height="16"
        fill={color}
        opacity="0"
      />
      <g id="Icon">
        <rect id="Canvas" width="16" height="16" fill="#464646" opacity="0" />
        <path
          id="Path_12998"
          data-name="Path 12998"
          d="M14.863,13.548l-3.455-3.454a5.7,5.7,0,1,0-1.314,1.314l3.454,3.454a.933.933,0,0,0,1.315-1.315ZM2.786,6.786a4,4,0,1,1,4,4,4,4,0,0,1-4-4Z"
          transform="translate(-0.119 -0.119)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const ContactsIcon = ({
  color,
  height,
  width,
}: {
  color: string;
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "12.632"}
      height={height || "16"}
      viewBox="0 0 12.632 16"
    >
      <path
        id="contact_page_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M186.316-850.51a1.422,1.422,0,0,0,1.044-.43,1.422,1.422,0,0,0,.43-1.044,1.422,1.422,0,0,0-.43-1.044,1.421,1.421,0,0,0-1.044-.43,1.421,1.421,0,0,0-1.044.43,1.422,1.422,0,0,0-.43,1.044,1.422,1.422,0,0,0,.43,1.044A1.422,1.422,0,0,0,186.316-850.51Zm-3.158,3.109h6.316v-.306a1.364,1.364,0,0,0-.241-.8,1.546,1.546,0,0,0-.661-.535,6,6,0,0,0-1.086-.346,5.5,5.5,0,0,0-1.17-.122,5.494,5.494,0,0,0-1.17.122,6,6,0,0,0-1.086.346,1.546,1.546,0,0,0-.661.535,1.364,1.364,0,0,0-.241.8Zm7.951,3.4h-9.587a1.469,1.469,0,0,1-1.08-.442,1.469,1.469,0,0,1-.442-1.08v-12.955a1.469,1.469,0,0,1,.442-1.08,1.469,1.469,0,0,1,1.08-.442h5.669a1.494,1.494,0,0,1,.585.118,1.507,1.507,0,0,1,.488.326l3.922,3.922a1.509,1.509,0,0,1,.325.488,1.492,1.492,0,0,1,.118.585v9.038a1.469,1.469,0,0,1-.442,1.08A1.469,1.469,0,0,1,191.109-844Zm0-1.263a.247.247,0,0,0,.178-.081.247.247,0,0,0,.081-.178v-9.13l-4.084-4.084h-5.762a.247.247,0,0,0-.178.081.247.247,0,0,0-.081.178v12.955a.247.247,0,0,0,.081.178.247.247,0,0,0,.178.081Zm-9.846,0v0Z"
        transform="translate(-180 860)"
        fill={color}
      />
    </svg>
  );
};

export const TemplatesIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="12.632"
      height="16"
      viewBox="0 0 12.632 16"
    >
      <path
        id="description_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M183.789-847.158h5.053a.611.611,0,0,0,.45-.181.611.611,0,0,0,.181-.45.611.611,0,0,0-.181-.45.611.611,0,0,0-.45-.181h-5.053a.611.611,0,0,0-.45.181.611.611,0,0,0-.181.45.611.611,0,0,0,.181.45A.611.611,0,0,0,183.789-847.158Zm0-3.368h5.053a.611.611,0,0,0,.45-.181.611.611,0,0,0,.181-.45.611.611,0,0,0-.181-.45.611.611,0,0,0-.45-.181h-5.053a.611.611,0,0,0-.45.181.611.611,0,0,0-.181.45.611.611,0,0,0,.181.45A.611.611,0,0,0,183.789-850.526ZM181.522-844a1.469,1.469,0,0,1-1.08-.442,1.469,1.469,0,0,1-.442-1.08v-12.955a1.469,1.469,0,0,1,.442-1.08,1.469,1.469,0,0,1,1.08-.442h6.058a1.5,1.5,0,0,1,.585.118,1.511,1.511,0,0,1,.488.325l3.533,3.534a1.51,1.51,0,0,1,.325.488,1.494,1.494,0,0,1,.118.585v9.427a1.469,1.469,0,0,1-.442,1.08,1.469,1.469,0,0,1-1.08.442Zm6.057-11.709v-3.028h-6.057a.247.247,0,0,0-.178.081.247.247,0,0,0-.081.178v12.955a.247.247,0,0,0,.081.178.247.247,0,0,0,.178.081h9.587a.247.247,0,0,0,.178-.081.247.247,0,0,0,.081-.178v-9.425H188.34a.737.737,0,0,1-.543-.218A.737.737,0,0,1,187.579-855.709Zm-6.316-3.028v0Z"
        transform="translate(-180 860)"
        fill={color}
      />
    </svg>
  );
};

export const CustomResponsesIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12.217"
      viewBox="0 0 16 12.217"
    >
      <path
        id="prompt_suggestion_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_"
        data-name="prompt_suggestion_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)"
        d="M153.593-732.043h-9.587a3.884,3.884,0,0,1-2.838-1.157A3.819,3.819,0,0,1,140-736.022a3.819,3.819,0,0,1,1.168-2.822A3.884,3.884,0,0,1,144.006-740a.7.7,0,0,1,.514.208.7.7,0,0,1,.208.514.7.7,0,0,1-.208.514.7.7,0,0,1-.514.207,2.493,2.493,0,0,0-1.814.735,2.427,2.427,0,0,0-.749,1.8,2.424,2.424,0,0,0,.749,1.8,2.494,2.494,0,0,0,1.814.735h9.587l-3.062-3.049a.7.7,0,0,1-.215-.5.666.666,0,0,1,.212-.516.7.7,0,0,1,.507-.2.673.673,0,0,1,.5.2l4.2,4.167a.847.847,0,0,1,.261.615.839.839,0,0,1-.261.612l-4.2,4.167a.657.657,0,0,1-.5.206.728.728,0,0,1-.5-.221.731.731,0,0,1-.217-.507.654.654,0,0,1,.217-.507Z"
        transform="translate(-140 740)"
        fill={color}
      />
    </svg>
  );
};

export const NotesIcon = ({ color }: { color: string }) => {
  return (
    <svg
      className="spectrum-Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14.316"
      height="16"
      viewBox="0 0 14.316 16"
    >
      <path
        id="note_alt_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M141.522-884a1.467,1.467,0,0,1-1.076-.446,1.467,1.467,0,0,1-.446-1.076v-11.271a1.467,1.467,0,0,1,.446-1.076,1.467,1.467,0,0,1,1.076-.446h3.747a1.862,1.862,0,0,1,.612-1.193,1.816,1.816,0,0,1,1.276-.492,1.827,1.827,0,0,1,1.284.492,1.827,1.827,0,0,1,.6,1.193h3.747a1.467,1.467,0,0,1,1.076.446,1.467,1.467,0,0,1,.446,1.076v11.271a1.467,1.467,0,0,1-.446,1.076,1.467,1.467,0,0,1-1.076.446Zm0-1.263h11.271a.247.247,0,0,0,.178-.081.247.247,0,0,0,.081-.178v-11.271a.247.247,0,0,0-.081-.178.247.247,0,0,0-.178-.081H141.522a.247.247,0,0,0-.178.081.247.247,0,0,0-.081.178v11.271a.247.247,0,0,0,.081.178A.247.247,0,0,0,141.522-885.263Zm5.636-12.34a.613.613,0,0,0,.453-.179.613.613,0,0,0,.179-.453.614.614,0,0,0-.179-.453.614.614,0,0,0-.453-.179.614.614,0,0,0-.453.179.614.614,0,0,0-.179.453.613.613,0,0,0,.179.453A.613.613,0,0,0,147.158-897.6Zm-5.895,12.34v0Zm2.389-2.008h.63a.7.7,0,0,0,.29-.061.8.8,0,0,0,.243-.167l4.792-4.75-1.357-1.357-4.75,4.75a.764.764,0,0,0-.173.256.775.775,0,0,0-.055.29v.659a.365.365,0,0,0,.114.266A.365.365,0,0,0,143.652-887.271Zm6.479-5.5.787-.813a.4.4,0,0,0,.126-.295.4.4,0,0,0-.126-.295l-.741-.741a.4.4,0,0,0-.295-.126.4.4,0,0,0-.295.126l-.813.787Z"
        transform="translate(-140 900)"
        fill={color}
      />
    </svg>
  );
};

export const LikeOutlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        className="fill"
        d="M14.922,6.004l-3.275.005a10.73706,10.73706,0,0,0,.4-3.04A1.90165,1.90165,0,0,0,10.4605,1,1.6635,1.6635,0,0,0,8.82,2.582C8.5845,4.8595,6.1935,6.7135,4.936,7.2685A.495.495,0,0,0,4.5,7h-3a.5.5,0,0,0-.5.5v8a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V15h7.222a2.318,2.318,0,0,0,2.063-1.2115L16.277,8.15a1.5,1.5,0,0,0-1.355-2.146Zm.4525,1.712L13.366,13.394a.921.921,0,0,1-.871.616L5,14V8.3c1.4335-.5765,4.575-2.7625,4.82-5.7a.687.687,0,0,1,.6405-.6c.305,0,.5605.371.5865.969A7.52457,7.52457,0,0,1,10.174,7h4.75a.5.5,0,0,1,.4505.716Z"
      />
    </svg>
  );
};

export const LikeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <rect fill="#464646" height="9" rx="0.5" width="3" x="1" y="7" />
      <path
        fill="#464646"
        d="M15.4835,7H10.5A27.46988,27.46988,0,0,0,11,2.46C11,1.6295,10.484,1,10,1A.9195.9195,0,0,0,9,2,5.663,5.663,0,0,1,7.742,5.129,23.17516,23.17516,0,0,1,5,7.521V15s1.4045-.0165,7,0a1.973,1.973,0,0,0,1.8385-1.212l2.564-5.394A1,1,0,0,0,15.4835,7Z"
      />
    </svg>
  );
};
export const DislikeOutlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <path
        className="fill"
        d="M16.277,9.85,14.285,4.212A2.318,2.318,0,0,0,12.222,3H5a.5.5,0,0,0-.5-.5h-3A.5.5,0,0,0,1,3v8a.5.5,0,0,0,.5.5h3A.5.5,0,0,0,5,11v-.238c1.2725.587,3.5885,2.415,3.82,4.656A1.6635,1.6635,0,0,0,10.4605,17a1.9023,1.9023,0,0,0,1.5865-1.9685,10.73831,10.73831,0,0,0-.4-3.0405l3.275.005A1.5,1.5,0,0,0,16.277,9.85ZM14.9235,11h-4.75a7.52559,7.52559,0,0,1,.873,4.0315c-.026.6-.2815.966-.5865.9685a.687.687,0,0,1-.6405-.6c-.245-2.9365-3.3865-5.1225-4.82-5.7V4l7.4955-.01a.921.921,0,0,1,.871.616l2.0085,5.678a.5.5,0,0,1-.451.716Z"
      />
    </svg>
  );
};

export const DislikeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" />
      <rect fill="#464646" height="9" rx="0.5" width="3" x="1" y="3" />
      <path
        fill="#464646"
        d="M15.5385,10.945H10.555A31.9301,31.9301,0,0,1,11,15.54c0,.8305-.516,1.46-1,1.46a.9195.9195,0,0,1-1-1,5.663,5.663,0,0,0-1.258-3.129A23.17516,23.17516,0,0,0,5,10.479V3s1.4045.0165,7,0a1.973,1.973,0,0,1,1.8385,1.212l2.564,5.394a.931.931,0,0,1-.864,1.339Z"
      />
    </svg>
  );
};
export const RefreshIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <rect id="Canvas" fill={color} opacity="0" width="18" height="18" />
      <path
        className="fill"
        fill={color}
        d="M16.337,10H15.39a.6075.6075,0,0,0-.581.469A5.7235,5.7235,0,0,1,5.25,13.006l-.346-.3465L6.8815,10.682A.392.392,0,0,0,7,10.4a.4.4,0,0,0-.377-.4H1.25a.25.25,0,0,0-.25.25v5.375A.4.4,0,0,0,1.4,16a.3905.3905,0,0,0,.28-.118l1.8085-1.8085.178.1785a8.09048,8.09048,0,0,0,3.642,2.1655,7.715,7.715,0,0,0,9.4379-5.47434q.04733-.178.0861-.35816A.5.5,0,0,0,16.337,10Z"
      />
      <path
        className="fill"
        fill={color}
        d="M16.6,2a.3905.3905,0,0,0-.28.118L14.5095,3.9265l-.178-.1765a8.09048,8.09048,0,0,0-3.642-2.1655A7.715,7.715,0,0,0,1.25269,7.06072q-.04677.17612-.08519.35428A.5.5,0,0,0,1.663,8H2.61a.6075.6075,0,0,0,.581-.469A5.7235,5.7235,0,0,1,12.75,4.994l.346.3465L11.1185,7.318A.392.392,0,0,0,11,7.6a.4.4,0,0,0,.377.4H16.75A.25.25,0,0,0,17,7.75V2.377A.4.4,0,0,0,16.6,2Z"
      />
    </svg>
  );
};

export const PhoneDisabledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47.726"
      height="48"
      viewBox="0 0 47.726 48"
    >
      <path
        id="phone_disabled_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M142.185-772.574l-12.972-12.972a47.921,47.921,0,0,1-12.507,7.734,34.373,34.373,0,0,1-13.31,2.748,2.646,2.646,0,0,1-2.117-.793,2.928,2.928,0,0,1-.684-1.982v-8.57a2.647,2.647,0,0,1,.633-1.772,2.915,2.915,0,0,1,1.634-.968l7.34-1.495a3.676,3.676,0,0,1,1.78.135,3.684,3.684,0,0,1,1.556.9l5.931,5.983q1.647-.93,3.556-2.249a40.05,40.05,0,0,0,3.322-2.534L98.368-816.391a1.913,1.913,0,0,1-.562-1.38,1.869,1.869,0,0,1,.562-1.406,1.9,1.9,0,0,1,1.393-.574,1.9,1.9,0,0,1,1.392.574L144.97-775.36a1.915,1.915,0,0,1,.562,1.38,1.869,1.869,0,0,1-.562,1.406,1.9,1.9,0,0,1-1.393.574A1.9,1.9,0,0,1,142.185-772.574Zm-26.494-9.261-4.666-4.718a.655.655,0,0,0-.242-.165.421.421,0,0,0-.267.013l-5.551,1.169a.546.546,0,0,0-.3.178.512.512,0,0,0-.1.33v5.561a.345.345,0,0,0,.1.254.345.345,0,0,0,.254.1,28.553,28.553,0,0,0,5.314-.811,29.227,29.227,0,0,0,5.462-1.914Zm19.956-10.354-2.785-2.786a32.937,32.937,0,0,0,2.155-2.869,33.509,33.509,0,0,0,1.835-3l-6.1-5.943a2.922,2.922,0,0,1-.816-1.5,3.874,3.874,0,0,1-.054-1.667l1.515-7.777a2.915,2.915,0,0,1,.968-1.634,2.647,2.647,0,0,1,1.772-.633h8.621a2.668,2.668,0,0,1,1.982.806,2.734,2.734,0,0,1,.793,2,33.851,33.851,0,0,1-2.674,13.043A47.012,47.012,0,0,1,135.648-792.19Zm3.04-12.408a33.662,33.662,0,0,0,1.909-5.577,33.842,33.842,0,0,0,.887-5.5.345.345,0,0,0-.1-.254.345.345,0,0,0-.254-.1h-5.612a.512.512,0,0,0-.33.1.545.545,0,0,0-.178.3l-1.189,5.907a.576.576,0,0,0-.013.318.592.592,0,0,0,.165.292l4.717,4.514ZM138.687-804.6ZM115.691-781.836Z"
        transform="translate(-97.806 820)"
        fill="#747474"
      />
    </svg>
  );
};

export const ForwardPhoneCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.916"
      height="18"
      viewBox="0 0 17.916 18"
    >
      <path
        id="phone_forwarded_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M155.355-846.248h-4.83a.736.736,0,0,1-.542-.218.735.735,0,0,1-.218-.542.736.736,0,0,1,.218-.542.736.736,0,0,1,.542-.218h4.83l-1.31-1.31a.753.753,0,0,1-.223-.521.73.73,0,0,1,.208-.547.781.781,0,0,1,.55-.244.726.726,0,0,1,.55.228l2.512,2.543a.879.879,0,0,1,.275.641.879.879,0,0,1-.275.641l-2.528,2.5a.77.77,0,0,1-.529.215.748.748,0,0,1-.539-.215.774.774,0,0,1-.244-.542.718.718,0,0,1,.228-.542Zm.8,13.858a13.663,13.663,0,0,1-5.757-1.332,18.392,18.392,0,0,1-5.318-3.759,18.5,18.5,0,0,1-3.749-5.313A13.629,13.629,0,0,1,140-848.546a1.049,1.049,0,0,1,.3-.765,1.023,1.023,0,0,1,.76-.309h3.306a1.012,1.012,0,0,1,.677.251,1.1,1.1,0,0,1,.373.619l.581,2.982a1.706,1.706,0,0,1-.025.713,1.062,1.062,0,0,1-.308.5l-2.341,2.279a14.049,14.049,0,0,0,1.291,1.958,19.276,19.276,0,0,0,1.572,1.763,17.452,17.452,0,0,0,1.774,1.55,17.836,17.836,0,0,0,2.029,1.331l2.274-2.294a1.288,1.288,0,0,1,.576-.347,1.654,1.654,0,0,1,.7-.049l2.814.573a1.192,1.192,0,0,1,.627.392,1,1,0,0,1,.243.659v3.286a1.023,1.023,0,0,1-.309.76A1.048,1.048,0,0,1,156.156-832.39Zm-13.548-11.324,1.809-1.731a.181.181,0,0,0,.063-.107.237.237,0,0,0,0-.127l-.441-2.265a.209.209,0,0,0-.068-.117.2.2,0,0,0-.127-.039h-2.167a.132.132,0,0,0-.1.039.133.133,0,0,0-.039.1,12.939,12.939,0,0,0,.34,2.111A12.887,12.887,0,0,0,142.608-843.714Zm8.818,8.759a10.425,10.425,0,0,0,2.1.718,11.944,11.944,0,0,0,2.046.3.132.132,0,0,0,.1-.039.132.132,0,0,0,.039-.1v-2.132a.2.2,0,0,0-.039-.127.209.209,0,0,0-.117-.068l-2.128-.433a.16.16,0,0,0-.1,0,.25.25,0,0,0-.093.063ZM142.608-843.714ZM151.426-834.955Z"
        transform="translate(-140 850.39)"
        fill="#464646"
      />
    </svg>
  );
};

export const MergeCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.961"
      height="18"
      viewBox="0 0 13.961 18"
    >
      <path
        id="merge_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M233.971-793.374l-5.6,5.6a.776.776,0,0,1-.562.232.781.781,0,0,1-.579-.243.78.78,0,0,1-.229-.575.781.781,0,0,1,.229-.576l4.663-4.68a4.356,4.356,0,0,0,.959-1.359,4.153,4.153,0,0,0,.293-1.628v-6.193l-1.479,1.48a.764.764,0,0,1-.562.229.792.792,0,0,1-.579-.246.781.781,0,0,1-.229-.575.781.781,0,0,1,.229-.576l2.749-2.76a.956.956,0,0,1,.7-.3.956.956,0,0,1,.7.3l2.759,2.76a.794.794,0,0,1,.238.562.763.763,0,0,1-.238.579.78.78,0,0,1-.575.229.781.781,0,0,1-.576-.229l-1.479-1.452v6.193a4.1,4.1,0,0,0,.3,1.638,4.472,4.472,0,0,0,.97,1.369l4.652,4.669a.8.8,0,0,1,.237.562.762.762,0,0,1-.237.579.781.781,0,0,1-.576.229.78.78,0,0,1-.575-.229Z"
        transform="translate(-227 805.54)"
        fill="#464646"
      />
    </svg>
  );
};

export const AddCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        id="add_call_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M153.235-815.235h-2.382a.769.769,0,0,1-.566-.228.769.769,0,0,1-.228-.566.768.768,0,0,1,.228-.566.769.769,0,0,1,.566-.228h2.382v-2.382a.768.768,0,0,1,.228-.566.769.769,0,0,1,.566-.228.767.767,0,0,1,.566.228.768.768,0,0,1,.228.566v2.382h2.382a.768.768,0,0,1,.566.228.769.769,0,0,1,.228.566.767.767,0,0,1-.228.566.768.768,0,0,1-.566.228h-2.382v2.382a.769.769,0,0,1-.228.566.769.769,0,0,1-.566.228.768.768,0,0,1-.566-.228.769.769,0,0,1-.228-.566ZM156.878-802a14.275,14.275,0,0,1-6.014-1.392,19.148,19.148,0,0,1-5.551-3.927,19.282,19.282,0,0,1-3.922-5.551A14.238,14.238,0,0,1,140-818.878a1.093,1.093,0,0,1,.318-.8,1.073,1.073,0,0,1,.794-.32h3.453a1.057,1.057,0,0,1,.708.262,1.15,1.15,0,0,1,.39.646l.607,3.115a1.783,1.783,0,0,1-.026.745,1.108,1.108,0,0,1-.322.523l-2.445,2.38a14.684,14.684,0,0,0,1.349,2.045,20.143,20.143,0,0,0,1.642,1.841,18.241,18.241,0,0,0,1.853,1.619,18.635,18.635,0,0,0,2.12,1.391l2.376-2.4a1.346,1.346,0,0,1,.6-.363,1.729,1.729,0,0,1,.734-.051l2.94.6a1.244,1.244,0,0,1,.655.409,1.044,1.044,0,0,1,.254.688v3.433a1.072,1.072,0,0,1-.321.794A1.093,1.093,0,0,1,156.878-802Zm-14.154-11.83,1.89-1.808a.189.189,0,0,0,.066-.112.247.247,0,0,0-.005-.132l-.46-2.366a.219.219,0,0,0-.071-.122.206.206,0,0,0-.132-.041h-2.264a.138.138,0,0,0-.1.041.139.139,0,0,0-.041.1,13.52,13.52,0,0,0,.355,2.205A13.466,13.466,0,0,0,142.724-813.83Zm9.212,9.151a10.9,10.9,0,0,0,2.2.75,12.462,12.462,0,0,0,2.137.308.138.138,0,0,0,.1-.041.138.138,0,0,0,.041-.1v-2.227a.205.205,0,0,0-.041-.132.219.219,0,0,0-.122-.071l-2.224-.452a.167.167,0,0,0-.107-.005.263.263,0,0,0-.1.066ZM142.724-813.83ZM151.936-804.68Z"
        transform="translate(-140 820)"
        fill="#464646"
      />
    </svg>
  );
};

export const BackspaceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16.174"
      viewBox="0 0 20 16.174"
    >
      <path
        id="backspace_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_"
        data-name="backspace_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)"
        d="M129.806-770.777l2.235,2.236a.782.782,0,0,0,.563.229.762.762,0,0,0,.573-.229.775.775,0,0,0,.234-.568.774.774,0,0,0-.234-.568l-2.235-2.235,2.235-2.235a.781.781,0,0,0,.229-.563.763.763,0,0,0-.229-.573.773.773,0,0,0-.568-.234.774.774,0,0,0-.568.234l-2.235,2.236-2.236-2.236a.782.782,0,0,0-.563-.229.762.762,0,0,0-.573.229.774.774,0,0,0-.234.568.774.774,0,0,0,.234.568l2.235,2.235-2.235,2.235a.781.781,0,0,0-.229.563.763.763,0,0,0,.229.573.774.774,0,0,0,.568.234.773.773,0,0,0,.568-.234Zm-5.112,6.951a1.977,1.977,0,0,1-.877-.2,1.817,1.817,0,0,1-.682-.566l-4.655-6.138a1.9,1.9,0,0,1-.4-1.18,1.9,1.9,0,0,1,.4-1.18l4.655-6.138a1.816,1.816,0,0,1,.682-.566,1.977,1.977,0,0,1,.877-.2h11.436a1.878,1.878,0,0,1,1.378.571,1.878,1.878,0,0,1,.571,1.378v12.276a1.879,1.879,0,0,1-.571,1.378,1.878,1.878,0,0,1-1.378.571Zm0-1.617h11.436a.323.323,0,0,0,.239-.093.323.323,0,0,0,.093-.239v-12.276a.323.323,0,0,0-.093-.239.323.323,0,0,0-.239-.093H124.695a.356.356,0,0,0-.15.031.342.342,0,0,0-.119.094l-4.655,6.138a.33.33,0,0,0-.073.207.33.33,0,0,0,.073.207l4.655,6.138a.341.341,0,0,0,.119.094A.355.355,0,0,0,124.695-765.443ZM128.075-771.913Z"
        transform="translate(-118.08 780)"
        fill="#505050"
      />
    </svg>
  );
};

export const OnCallIcon = () => {
  return (
    <svg
      id="On_Call_Icon"
      data-name="On_Call Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <circle
        id="Ellipse_98"
        data-name="Ellipse 98"
        cx="10"
        cy="10"
        r="10"
        fill="#007a4d"
      />
      <g id="Icon" transform="translate(-10 -3)">
        <rect
          id="Canvas"
          width="12"
          height="12"
          transform="translate(14 7)"
          fill="#fff"
          opacity="0"
        />
        <path
          id="call_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_"
          data-name="call_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)"
          d="M150-809.333a8.461,8.461,0,0,1-3.564-.825,11.348,11.348,0,0,1-3.289-2.327,11.427,11.427,0,0,1-2.324-3.289,8.438,8.438,0,0,1-.825-3.561.648.648,0,0,1,.188-.475.636.636,0,0,1,.471-.19h2.046a.627.627,0,0,1,.419.155.681.681,0,0,1,.231.383l.36,1.846a1.057,1.057,0,0,1-.016.442.658.658,0,0,1-.191.31l-1.449,1.411a8.7,8.7,0,0,0,.8,1.212,11.953,11.953,0,0,0,.973,1.091,10.831,10.831,0,0,0,1.1.959,11.046,11.046,0,0,0,1.256.824l1.408-1.42a.8.8,0,0,1,.357-.215,1.023,1.023,0,0,1,.435-.03l1.742.355a.736.736,0,0,1,.388.242.618.618,0,0,1,.15.408v2.034a.635.635,0,0,1-.19.471A.647.647,0,0,1,150-809.333Zm-8.387-7.01,1.12-1.072a.112.112,0,0,0,.039-.066.147.147,0,0,0,0-.078l-.273-1.4a.13.13,0,0,0-.042-.072.121.121,0,0,0-.078-.024h-1.342a.082.082,0,0,0-.06.024.082.082,0,0,0-.024.06,8.006,8.006,0,0,0,.211,1.307A7.986,7.986,0,0,0,141.614-816.344Zm5.459,5.423a6.464,6.464,0,0,0,1.3.445,7.375,7.375,0,0,0,1.266.183.081.081,0,0,0,.06-.024.082.082,0,0,0,.024-.06v-1.32a.122.122,0,0,0-.024-.079.131.131,0,0,0-.072-.042l-1.318-.268a.1.1,0,0,0-.063,0,.155.155,0,0,0-.057.039ZM141.614-816.344ZM147.073-810.921Z"
          transform="translate(-125.333 827.667)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.2"
        />
      </g>
    </svg>
  );
};

export const RefreshTimerIcon = () => {
  return (
    <svg
      fill="#000000"
      height="18"
      width="18"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      enable-background="new 0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path d="M256,0C179.9,0,111.7,33.4,64.9,86.2L0,21.3V192h170.7l-60.2-60.2C145.6,90.5,197.5,64,256,64c106,0,192,85.9,192,192 c0,106.1-86,192-192,192c-53,0-101-21.5-135.8-56.2L75,437c46.4,46.3,110.4,75,181,75c141.4,0,256-114.6,256-256S397.4,0,256,0z M234.7,106.7v170.7h128v-42.7h-85.3v-128H234.7z" />{" "}
      </g>
    </svg>
  );
};

export const TimerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g
        id="Group_172161"
        data-name="Group 172161"
        transform="translate(-617 -173)"
      >
        <g
          id="Rectangle_137361"
          data-name="Rectangle 137361"
          transform="translate(617 173)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="18" height="18" stroke="none" />
          <rect x="0.5" y="0.5" width="17" height="17" fill="none" />
        </g>
        <path
          id="timer_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M145.726-908.667a.644.644,0,0,1-.475-.192.645.645,0,0,1-.192-.475.644.644,0,0,1,.192-.475.645.645,0,0,1,.475-.192h3.658a.644.644,0,0,1,.475.192.645.645,0,0,1,.192.475.644.644,0,0,1-.192.475.645.645,0,0,1-.475.192Zm1.829,9.829a.644.644,0,0,0,.475-.192.645.645,0,0,0,.192-.475v-3.658a.644.644,0,0,0-.192-.475.645.645,0,0,0-.475-.192.644.644,0,0,0-.475.192.645.645,0,0,0-.192.475v3.658a.644.644,0,0,0,.192.475A.645.645,0,0,0,147.556-898.838Zm0,6.838a7.308,7.308,0,0,1-2.931-.595,7.666,7.666,0,0,1-2.405-1.624,7.667,7.667,0,0,1-1.624-2.405,7.309,7.309,0,0,1-.595-2.931,7.309,7.309,0,0,1,.595-2.931,7.666,7.666,0,0,1,1.624-2.405,7.667,7.667,0,0,1,2.405-1.624,7.309,7.309,0,0,1,2.931-.595,7.417,7.417,0,0,1,2.572.453,8.184,8.184,0,0,1,2.3,1.3l.639-.639a.644.644,0,0,1,.464-.189A.629.629,0,0,1,154-906a.638.638,0,0,1,.193.468.638.638,0,0,1-.193.468l-.639.639a8.186,8.186,0,0,1,1.3,2.3,7.417,7.417,0,0,1,.453,2.572,7.309,7.309,0,0,1-.595,2.931,7.667,7.667,0,0,1-1.624,2.405,7.666,7.666,0,0,1-2.405,1.624A7.308,7.308,0,0,1,147.556-892Zm0-1.333a6,6,0,0,0,4.4-1.822,6,6,0,0,0,1.822-4.4,6,6,0,0,0-1.822-4.4,6,6,0,0,0-4.4-1.822,6,6,0,0,0-4.4,1.822,6,6,0,0,0-1.822,4.4,6,6,0,0,0,1.822,4.4A6,6,0,0,0,147.556-893.333ZM147.556-899.556Z"
          transform="translate(478.444 1083)"
          fill="#464646"
        />
      </g>
    </svg>
  );
};

export const CallOutwardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g id="Call_Outward" transform="translate(344 255) rotate(180)">
        <g
          id="Rectangle_137279"
          data-name="Rectangle 137279"
          transform="translate(328 239)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="15" fill="none" />
        </g>
        <path
          id="call_made_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24"
          d="M187.353-757.2l-8.974,8.974a.781.781,0,0,1-.576.226.781.781,0,0,1-.576-.226A.781.781,0,0,1,177-748.8a.781.781,0,0,1,.226-.576l8.974-8.974H181.59a.8.8,0,0,1-.587-.237.8.8,0,0,1-.237-.587.8.8,0,0,1,.237-.587.8.8,0,0,1,.587-.237h6.587a.8.8,0,0,1,.587.237.8.8,0,0,1,.237.587v6.587a.8.8,0,0,1-.237.587.8.8,0,0,1-.587.237.8.8,0,0,1-.587-.237.8.8,0,0,1-.237-.587Z"
          transform="translate(519 -507) rotate(180)"
          fill="#464646"
        />
      </g>
    </svg>
  );
};

export const CallInwardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g id="Call_Inward" transform="translate(-328 -239)">
        <g
          id="Rectangle_137279"
          data-name="Rectangle 137279"
          transform="translate(328 239)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="15" fill="none" />
        </g>
        <path
          id="call_made_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24"
          d="M187.353-757.2l-8.974,8.974a.781.781,0,0,1-.576.226.781.781,0,0,1-.576-.226A.781.781,0,0,1,177-748.8a.781.781,0,0,1,.226-.576l8.974-8.974H181.59a.8.8,0,0,1-.587-.237.8.8,0,0,1-.237-.587.8.8,0,0,1,.237-.587.8.8,0,0,1,.587-.237h6.587a.8.8,0,0,1,.587.237.8.8,0,0,1,.237.587v6.587a.8.8,0,0,1-.237.587.8.8,0,0,1-.587.237.8.8,0,0,1-.587-.237.8.8,0,0,1-.237-.587Z"
          transform="translate(519 -507) rotate(180)"
          fill="#464646"
        />
      </g>
    </svg>
  );
};

export const BeingMonitoredIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        id="Call_Monitor"
        data-name="Call Monitor"
        transform="translate(3160 20528)"
      >
        <g
          id="Rectangle_137364"
          data-name="Rectangle 137364"
          transform="translate(-3160 -20528)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <g
          id="Group_172189"
          data-name="Group 172189"
          transform="translate(-784 -2102.906)"
        >
          <path
            id="multimodal_hand_eye_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
            d="M399.319-851.658a7.4,7.4,0,0,1-3.634-.927,7.457,7.457,0,0,1-2.725-2.574,1.206,1.206,0,0,1-.146-.318,1.3,1.3,0,0,1-.044-.352,1.3,1.3,0,0,1,.044-.352,1.184,1.184,0,0,1,.147-.318,7.308,7.308,0,0,1,2.714-2.574,7.426,7.426,0,0,1,3.639-.927,7.4,7.4,0,0,1,3.634.927,7.455,7.455,0,0,1,2.725,2.574,1.189,1.189,0,0,1,.146.318,1.3,1.3,0,0,1,.044.352,1.3,1.3,0,0,1-.044.352,1.182,1.182,0,0,1-.147.318,7.311,7.311,0,0,1-2.714,2.574A7.427,7.427,0,0,1,399.319-851.658Zm0-1.572a5.87,5.87,0,0,0,2.782-.691,6.112,6.112,0,0,0,2.166-1.908,6.116,6.116,0,0,0-2.165-1.908,5.86,5.86,0,0,0-2.781-.691,5.869,5.869,0,0,0-2.782.691,6.112,6.112,0,0,0-2.166,1.908,6.116,6.116,0,0,0,2.165,1.908,5.862,5.862,0,0,0,2.781.691Zm0-1.29a1.265,1.265,0,0,1-.928-.382,1.26,1.26,0,0,1-.383-.927,1.266,1.266,0,0,1,.382-.928,1.26,1.26,0,0,1,.927-.383,1.266,1.266,0,0,1,.928.382,1.26,1.26,0,0,1,.383.927,1.265,1.265,0,0,1-.382.928A1.259,1.259,0,0,1,399.318-854.519Z"
            transform="translate(-2758.864 -17562)"
            fill="#464646"
          />
          <path
            id="perm_phone_msg_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
            d="M156.7-802.187a14.126,14.126,0,0,1-5.951-1.377,18.949,18.949,0,0,1-5.493-3.886,19.082,19.082,0,0,1-3.881-5.493A14.09,14.09,0,0,1,140-818.89a1.081,1.081,0,0,1,.314-.793A1.061,1.061,0,0,1,141.1-820h3.417a1.046,1.046,0,0,1,.7.259,1.138,1.138,0,0,1,.386.64l.6,3.083a1.765,1.765,0,0,1-.026.737,1.1,1.1,0,0,1-.319.518l-2.42,2.356a14.526,14.526,0,0,0,1.335,2.024,19.932,19.932,0,0,0,1.625,1.822,18.05,18.05,0,0,0,1.834,1.6,18.428,18.428,0,0,0,2.1,1.376l2.351-2.372a1.333,1.333,0,0,1,.6-.359,1.713,1.713,0,0,1,.726-.05l2.91.593a1.231,1.231,0,0,1,.648.4,1.033,1.033,0,0,1,.251.681v3.4a1.061,1.061,0,0,1-.317.786A1.081,1.081,0,0,1,156.7-802.187ZM142.7-813.894l1.87-1.789a.187.187,0,0,0,.065-.111.245.245,0,0,0,0-.131l-.456-2.342a.216.216,0,0,0-.07-.121.2.2,0,0,0-.131-.04h-2.241a.137.137,0,0,0-.1.04.137.137,0,0,0-.04.1,13.381,13.381,0,0,0,.352,2.182A13.33,13.33,0,0,0,142.7-813.894Zm9.116,9.055a10.778,10.778,0,0,0,2.173.743,12.345,12.345,0,0,0,2.115.305.137.137,0,0,0,.1-.04.137.137,0,0,0,.04-.1v-2.2a.2.2,0,0,0-.04-.131.217.217,0,0,0-.121-.071l-2.2-.447a.166.166,0,0,0-.106-.005.261.261,0,0,0-.1.065ZM142.7-813.894ZM151.812-804.839Z"
            transform="translate(-2515 -17602)"
            fill="#464646"
          />
        </g>
      </g>
    </svg>
  );
};

export const AiCrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Icon_Close" transform="translate(22941 -5644)">
        <g
          id="Rectangle_137339"
          data-name="Rectangle 137339"
          transform="translate(-22941 5644)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_13187"
          data-name="Path 13187"
          d="M17.045,3.4,11.2,9.247,5.348,3.4a.689.689,0,0,0-.975,0L3.4,4.373a.689.689,0,0,0,0,.975L9.247,11.2,3.4,17.045a.689.689,0,0,0,0,.975l.975.975a.689.689,0,0,0,.975,0L11.2,13.146l5.848,5.849a.689.689,0,0,0,.975,0l.975-.975a.689.689,0,0,0,0-.975L13.146,11.2l5.849-5.848a.689.689,0,0,0,0-.975L18.02,3.4a.689.689,0,0,0-.975,0Z"
          transform="translate(-22940.197 5644.804)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const CrossIcon = ({ color }: { color: string }) => {
  return (
    <svg
      id="Action_button"
      data-name="Action button"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 32 32"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="24"
        height="24"
        fill="red"
        opacity="0"
      />
      <g
        id="Background"
        fill="rgba(255,255,255,0)"
        stroke="rgba(255,255,255,0)"
        strokeWidth="1"
      >
        <rect width="32" height="32" rx="4" stroke="none" />
        <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="none" />
      </g>
      <g id="Icon">
        <rect
          id="Canvas"
          width="18"
          height="18"
          transform="translate(7 7)"
          fill="#222"
          opacity="0"
        />
        <path
          id="Path_13229"
          data-name="Path 13229"
          d="M13.243,3.343,9,7.586,4.758,3.343a.5.5,0,0,0-.707,0l-.707.707a.5.5,0,0,0,0,.707L7.586,9,3.343,13.243a.5.5,0,0,0,0,.707l.707.707a.5.5,0,0,0,.707,0L9,10.414l4.243,4.243a.5.5,0,0,0,.707,0l.707-.707a.5.5,0,0,0,0-.707L10.414,9l4.243-4.242a.5.5,0,0,0,0-.707l-.707-.707a.5.5,0,0,0-.707,0Z"
          transform="translate(7 7)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const BellIconWithNotification = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.699"
      height="24"
      viewBox="0 0 18.699 24"
    >
      <g
        id="New_notification"
        data-name="New notification"
        transform="translate(22040 22753)"
      >
        <path
          id="Path_26489"
          data-name="Path 26489"
          d="M227.113-834.994a3.463,3.463,0,0,1-2.542-1.046,3.457,3.457,0,0,1-1.048-2.541,3.464,3.464,0,0,1,1.046-2.542,3.457,3.457,0,0,1,2.541-1.047,3.464,3.464,0,0,1,2.542,1.046,3.456,3.456,0,0,1,1.048,2.541,3.464,3.464,0,0,1-1.046,2.542A3.457,3.457,0,0,1,227.113-834.994Z"
          transform="translate(-22252 -21909)"
          fill="#ad0955"
        />
        <path
          id="Path_26492"
          data-name="Path 26492"
          d="M220.734-820a2,2,0,0,1-1.479-.616,2.031,2.031,0,0,1-.61-1.482h4.2a2.009,2.009,0,0,1-.619,1.488,2.044,2.044,0,0,1-1.488.61ZM220.743-832.442Zm-7.885,8.778a.84.84,0,0,1-.609-.242.8.8,0,0,1-.249-.6.833.833,0,0,1,.244-.606.813.813,0,0,1,.6-.248h.467v-8.432a7.289,7.289,0,0,1,1.739-4.834,7.087,7.087,0,0,1,4.449-2.506v-1.629a1.2,1.2,0,0,1,.361-.878,1.193,1.193,0,0,1,.877-.361,1.2,1.2,0,0,1,.879.361,1.194,1.194,0,0,1,.363.878v.718a7.58,7.58,0,0,0-.559,1.179,5.435,5.435,0,0,0-.312,1.343l-.193,0h-.176a5.531,5.531,0,0,0-4.064,1.668,5.53,5.53,0,0,0-1.667,4.064v8.432h11.463v-7.016a4.173,4.173,0,0,0,.851.039,6.473,6.473,0,0,0,.846-.1v7.079h.467a.824.824,0,0,1,.6.242.811.811,0,0,1,.244.6.833.833,0,0,1-.244.606.812.812,0,0,1-.6.248Z"
          transform="translate(-22252 -21909)"
        />
      </g>
    </svg>
  );
};
export const BellIconPlain = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.486" height="24" viewBox="0 0 17.486 24">
  <path id="Neutral" d="M212.858-823.664a.841.841,0,0,1-.609-.242.8.8,0,0,1-.249-.6.831.831,0,0,1,.244-.605.81.81,0,0,1,.6-.248h.467v-8.433a7.288,7.288,0,0,1,1.739-4.834,7.081,7.081,0,0,1,4.449-2.506v-1.629a1.2,1.2,0,0,1,.361-.878,1.193,1.193,0,0,1,.877-.361,1.2,1.2,0,0,1,.879.361,1.193,1.193,0,0,1,.363.878v1.629a7.082,7.082,0,0,1,4.449,2.506,7.288,7.288,0,0,1,1.739,4.834v8.433h.467a.824.824,0,0,1,.6.241.811.811,0,0,1,.244.6.834.834,0,0,1-.244.606.814.814,0,0,1-.6.248ZM220.743-832.441ZM220.734-820a2,2,0,0,1-1.479-.617,2.029,2.029,0,0,1-.61-1.481h4.2a2.009,2.009,0,0,1-.619,1.488A2.042,2.042,0,0,1,220.734-820Zm-5.722-5.359h11.463v-8.433a5.529,5.529,0,0,0-1.667-4.063,5.528,5.528,0,0,0-4.064-1.668,5.529,5.529,0,0,0-4.064,1.668,5.53,5.53,0,0,0-1.667,4.063Z" transform="translate(-212 844)"/>
</svg>
  )
};

export const BellIconSpectrum = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
    <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path fill="#464646" d="M9,18a2.203,2.203,0,0,0,2-2H7A2.203,2.203,0,0,0,9,18Z" />
    <path fill="#464646" d="M13.5715,5.6925c0-1.7185-1.603-2.4455-3.5715-2.634V1.5A.5395.5395,0,0,0,9.4285,1h-.857A.5395.5395,0,0,0,8,1.5V3.0585c-1.9685.1885-3.5715.9155-3.5715,2.634C4.4285,13.4,2,13.0555,2,14.077V15H16v-.923C16,13,13.5715,13.4,13.5715,5.6925Z" />
  </svg>
  )
}

export const BellIconAttention = ({ width = "18", height = "18" }: { width?: string; height?: string } = {}) => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 18 18" width={width}>
  <rect id="Canvas" fill="#ff13dc" opacity="0" width={width} height={height} />
  <path fill="#FF8C42" d="M9,18a2.203,2.203,0,0,0,2-2H7A2.203,2.203,0,0,0,9,18Z" />
  <path fill="#FF8C42" d="M13.5715,5.6925c0-1.7185-1.603-2.4455-3.5715-2.634V1.5A.5395.5395,0,0,0,9.4285,1h-.857A.5395.5395,0,0,0,8,1.5V3.0585c-1.9685.1885-3.5715.9155-3.5715,2.634C4.4285,13.4,2,13.0555,2,14.077V15H16v-.923C16,13,13.5715,13.4,13.5715,5.6925Z" />
</svg>
  )
}


export const BellIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.486"
      height="24"
      viewBox="0 0 17.486 24"
    >
      <path
        id="Neutral"
        d="M212.858-823.664a.841.841,0,0,1-.609-.242.8.8,0,0,1-.249-.6.831.831,0,0,1,.244-.605.81.81,0,0,1,.6-.248h.467v-8.433a7.288,7.288,0,0,1,1.739-4.834,7.081,7.081,0,0,1,4.449-2.506v-1.629a1.2,1.2,0,0,1,.361-.878,1.193,1.193,0,0,1,.877-.361,1.2,1.2,0,0,1,.879.361,1.193,1.193,0,0,1,.363.878v1.629a7.082,7.082,0,0,1,4.449,2.506,7.288,7.288,0,0,1,1.739,4.834v8.433h.467a.824.824,0,0,1,.6.241.811.811,0,0,1,.244.6.834.834,0,0,1-.244.606.814.814,0,0,1-.6.248ZM220.743-832.441ZM220.734-820a2,2,0,0,1-1.479-.617,2.029,2.029,0,0,1-.61-1.481h4.2a2.009,2.009,0,0,1-.619,1.488A2.042,2.042,0,0,1,220.734-820Zm-5.722-5.359h11.463v-8.433a5.529,5.529,0,0,0-1.667-4.063,5.528,5.528,0,0,0-4.064-1.668,5.529,5.529,0,0,0-4.064,1.668,5.53,5.53,0,0,0-1.667,4.063Z"
        transform="translate(-212 844)"
      />
    </svg>
  );
};

export const ConnectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="170px"
      height="143px"
      viewBox="0 0 47 42"
      version="1.1"
      transform="scale(0.8)"
      style={{ height: "25px", width: "25px" }}
    >
      <g
        id="Connect-Colors-V1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Metrics-Navigation-Copy-26"
          transform="translate(-9.000000, -10.000000)"
        >
          <g id="Header-Copy-6">
            <g id="Page-1-Copy-3" transform="translate(9.000000, 10.000000)">
              <path
                d="M39.5085902,13.257345 L39.5228232,13.1638025 C39.0806515,6.653621 33.1170263,5.52638639 30.4507118,9.12068687 L30.4507118,9.12163175 C29.7447552,7.13078234 28.6734851,5.29961664 27.2188729,3.84640051 C24.0724321,0.702804901 19.2891967,-0.971511728 14.0552498,1.23571381 C9.97891983,2.95443951 7.12662752,7.77140688 7.12662752,11.9553087 C7.12662752,12.447588 7.15604237,12.9323084 7.21297436,13.40758 L7.21297436,13.4047453 C4.23258508,14.164424 0.875495858,16.4255073 0.875495858,21.5334959 C0.875495858,21.6232589 0.876444725,21.7130219 0.878342457,21.8008952 C0.986513224,26.2635348 4.84175729,29.9457086 9.32420203,29.950433 L18.5661605,29.950433 L18.5661605,41.1991573 L30.7021614,29.950433 L38.4610417,29.950433 C39.4507093,29.9513778 40.4356326,29.7964185 41.3721637,29.477996 C43.6532385,28.7022545 46.9998902,26.6962871 46.9998902,21.6043614 C46.9998902,15.6280337 42.2204503,13.7212781 39.5085902,13.257345 Z"
                id="Stroke-3"
                fill="#00ABBA"
              ></path>
              <path
                d="M18.6412158,15.521074 L13.6444855,19.0407294"
                id="Stroke-11"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M24.4460007,21.6205188 L21.6003505,16.2300129"
                id="Stroke-13"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M32.399968,18.8097078 L27.4041865,22.3284183"
                id="Stroke-15"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M34.8235625,15.2443204 C33.5824453,14.94763 32.3337371,15.7091984 32.0357931,16.9450935 C31.737849,18.1819335 32.5026353,19.4244427 33.7447014,19.7211332 C34.9858186,20.0178236 36.2335779,19.2562552 36.531522,18.0203601 C36.829466,16.7835201 36.0646797,15.5410108 34.8235625,15.2443204 Z"
                id="Stroke-17"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M26.0599276,21.4170874 C24.8188103,21.120397 23.5701022,21.8819654 23.2721582,23.1178605 C22.9742141,24.3547005 23.7390004,25.5972097 24.9810665,25.8939002 C26.2221837,26.1905906 27.469943,25.4290222 27.767887,24.1931271 C28.0658311,22.9562871 27.3010448,21.7137778 26.0599276,21.4170874 Z"
                id="Stroke-19"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M21.0648103,11.9556867 C19.8236931,11.6589962 18.574985,12.4205646 18.2770409,13.6564598 C17.9790969,14.8932997 18.7438832,16.135809 19.9859492,16.4324994 C21.2270665,16.7291898 22.4748257,15.9676214 22.7727698,14.7317263 C23.0707138,13.4948863 22.3059275,12.2523771 21.0648103,11.9556867 Z"
                id="Stroke-21"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M12.3010805,18.1284536 C11.0599633,17.8317632 9.81125514,18.5933316 9.5133111,19.8292267 C9.21536706,21.0660667 9.98015336,22.308576 11.2222194,22.6052664 C12.4633367,22.9019568 13.7110959,22.1403884 14.00904,20.9044933 C14.306984,19.6676533 13.5421977,18.4251441 12.3010805,18.1284536 Z"
                id="Stroke-23"
                stroke="#26303B"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const QuestionMarkIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    >
      <g id="Icon_AI" transform="translate(22894 -5641)">
        <rect
          id="Rectangle_137340"
          data-name="Rectangle 137340"
          width={18}
          height={18}
          transform="translate(-22894 5641)"
          fill="#fff"
          opacity="0"
        />
        <path
          id="contact_support_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M151.732-838.78H150.61a10.236,10.236,0,0,1-7.52-3.089A10.231,10.231,0,0,1,140-849.388a10.241,10.241,0,0,1,3.089-7.521,10.231,10.231,0,0,1,7.52-3.091,10.366,10.366,0,0,1,4.139.828,10.687,10.687,0,0,1,3.37,2.274,10.693,10.693,0,0,1,2.274,3.368,10.356,10.356,0,0,1,.828,4.14,13.89,13.89,0,0,1-2.229,7.618,17.812,17.812,0,0,1-5.647,5.624,1.228,1.228,0,0,1-.51.147.813.813,0,0,1-.469-.114,1.213,1.213,0,0,1-.362-.329.92.92,0,0,1-.168-.49Zm2.193-.2a16.514,16.514,0,0,0,3.829-4.658,11.7,11.7,0,0,0,1.475-5.753,8.321,8.321,0,0,0-2.5-6.117,8.321,8.321,0,0,0-6.117-2.5,8.321,8.321,0,0,0-6.117,2.5,8.321,8.321,0,0,0-2.5,6.117,8.321,8.321,0,0,0,2.5,6.117,8.321,8.321,0,0,0,6.117,2.5h3.316Zm-3.309-3.418a1.121,1.121,0,0,0,.826-.343,1.131,1.131,0,0,0,.34-.828,1.121,1.121,0,0,0-.342-.826,1.131,1.131,0,0,0-.828-.341,1.121,1.121,0,0,0-.826.343,1.131,1.131,0,0,0-.34.828,1.121,1.121,0,0,0,.342.826A1.131,1.131,0,0,0,150.617-842.4Zm-2.819-9.926a.732.732,0,0,0,.594,0,1.091,1.091,0,0,0,.486-.4,2.033,2.033,0,0,1,.734-.664,2.128,2.128,0,0,1,1.023-.241,2.122,2.122,0,0,1,1.44.48,1.588,1.588,0,0,1,.554,1.262,1.871,1.871,0,0,1-.255.935,5.456,5.456,0,0,1-.885,1.08,7.2,7.2,0,0,0-1.227,1.4,2.326,2.326,0,0,0-.385,1.233.779.779,0,0,0,.226.563.733.733,0,0,0,.546.233.685.685,0,0,0,.534-.241,1.322,1.322,0,0,0,.3-.575,2.373,2.373,0,0,1,.52-.97q.405-.483.86-.937a5.456,5.456,0,0,0,1.057-1.4,3.043,3.043,0,0,0,.336-1.358,2.952,2.952,0,0,0-.994-2.324,3.773,3.773,0,0,0-2.6-.88,3.7,3.7,0,0,0-1.878.495,3.788,3.788,0,0,0-1.347,1.272.732.732,0,0,0-.068.614A.7.7,0,0,0,147.8-852.323ZM150.61-848.5Z"
          transform="translate(-23033 6501)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const AiQuestionMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Icon_AI" transform="translate(22894 -5641)">
        <rect
          id="Rectangle_137340"
          data-name="Rectangle 137340"
          width="24"
          height="24"
          transform="translate(-22894 5641)"
          fill="#fff"
          opacity="0"
        />
        <path
          id="contact_support_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M151.732-838.78H150.61a10.236,10.236,0,0,1-7.52-3.089A10.231,10.231,0,0,1,140-849.388a10.241,10.241,0,0,1,3.089-7.521,10.231,10.231,0,0,1,7.52-3.091,10.366,10.366,0,0,1,4.139.828,10.687,10.687,0,0,1,3.37,2.274,10.693,10.693,0,0,1,2.274,3.368,10.356,10.356,0,0,1,.828,4.14,13.89,13.89,0,0,1-2.229,7.618,17.812,17.812,0,0,1-5.647,5.624,1.228,1.228,0,0,1-.51.147.813.813,0,0,1-.469-.114,1.213,1.213,0,0,1-.362-.329.92.92,0,0,1-.168-.49Zm2.193-.2a16.514,16.514,0,0,0,3.829-4.658,11.7,11.7,0,0,0,1.475-5.753,8.321,8.321,0,0,0-2.5-6.117,8.321,8.321,0,0,0-6.117-2.5,8.321,8.321,0,0,0-6.117,2.5,8.321,8.321,0,0,0-2.5,6.117,8.321,8.321,0,0,0,2.5,6.117,8.321,8.321,0,0,0,6.117,2.5h3.316Zm-3.309-3.418a1.121,1.121,0,0,0,.826-.343,1.131,1.131,0,0,0,.34-.828,1.121,1.121,0,0,0-.342-.826,1.131,1.131,0,0,0-.828-.341,1.121,1.121,0,0,0-.826.343,1.131,1.131,0,0,0-.34.828,1.121,1.121,0,0,0,.342.826A1.131,1.131,0,0,0,150.617-842.4Zm-2.819-9.926a.732.732,0,0,0,.594,0,1.091,1.091,0,0,0,.486-.4,2.033,2.033,0,0,1,.734-.664,2.128,2.128,0,0,1,1.023-.241,2.122,2.122,0,0,1,1.44.48,1.588,1.588,0,0,1,.554,1.262,1.871,1.871,0,0,1-.255.935,5.456,5.456,0,0,1-.885,1.08,7.2,7.2,0,0,0-1.227,1.4,2.326,2.326,0,0,0-.385,1.233.779.779,0,0,0,.226.563.733.733,0,0,0,.546.233.685.685,0,0,0,.534-.241,1.322,1.322,0,0,0,.3-.575,2.373,2.373,0,0,1,.52-.97q.405-.483.86-.937a5.456,5.456,0,0,0,1.057-1.4,3.043,3.043,0,0,0,.336-1.358,2.952,2.952,0,0,0-.994-2.324,3.773,3.773,0,0,0-2.6-.88,3.7,3.7,0,0,0-1.878.495,3.788,3.788,0,0,0-1.347,1.272.732.732,0,0,0-.068.614A.7.7,0,0,0,147.8-852.323ZM150.61-848.5Z"
          transform="translate(-23033 6501)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const RefreshIconRotate = ({
  color,
  className,
}: {
  color: string;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      className={className}
    >
      <rect id="Canvas" fill={color} opacity="0" width="18" height="18" />
      <path
        className="fill"
        fill={color}
        d="M16.337,10H15.39a.6075.6075,0,0,0-.581.469A5.7235,5.7235,0,0,1,5.25,13.006l-.346-.3465L6.8815,10.682A.392.392,0,0,0,7,10.4a.4.4,0,0,0-.377-.4H1.25a.25.25,0,0,0-.25.25v5.375A.4.4,0,0,0,1.4,16a.3905.3905,0,0,0,.28-.118l1.8085-1.8085.178.1785a8.09048,8.09048,0,0,0,3.642,2.1655,7.715,7.715,0,0,0,9.4379-5.47434q.04733-.178.0861-.35816A.5.5,0,0,0,16.337,10Z"
      />
      <path
        className="fill"
        fill={color}
        d="M16.6,2a.3905.3905,0,0,0-.28.118L14.5095,3.9265l-.178-.1765a8.09048,8.09048,0,0,0-3.642-2.1655A7.715,7.715,0,0,0,1.25269,7.06072q-.04677.17612-.08519.35428A.5.5,0,0,0,1.663,8H2.61a.6075.6075,0,0,0,.581-.469A5.7235,5.7235,0,0,1,12.75,4.994l.346.3465L11.1185,7.318A.392.392,0,0,0,11,7.6a.4.4,0,0,0,.377.4H16.75A.25.25,0,0,0,17,7.75V2.377A.4.4,0,0,0,16.6,2Z"
      />
    </svg>
  );
};

export const CallRinging = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g id="Icon" transform="translate(-198 -7)">
        <rect
          id="Canvas"
          width="28"
          height="28"
          transform="translate(198 7)"
          fill="#222"
          opacity="0"
        />
        <path
          id="phone_in_talk_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_"
          data-name="phone_in_talk_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)"
          d="M162.072-817.191a1.032,1.032,0,0,1-.723-.292,1.136,1.136,0,0,1-.365-.724,9.506,9.506,0,0,0-2.764-5.6,9.508,9.508,0,0,0-5.6-2.764,1.16,1.16,0,0,1-.725-.35,1.027,1.027,0,0,1-.292-.737.966.966,0,0,1,.3-.723.823.823,0,0,1,.714-.233,11.441,11.441,0,0,1,7.057,3.366,11.442,11.442,0,0,1,3.366,7.057.822.822,0,0,1-.233.714A.972.972,0,0,1,162.072-817.191Zm-5.608,0a.857.857,0,0,1-.583-.226,1.378,1.378,0,0,1-.383-.6,4.453,4.453,0,0,0-1.138-1.94,4.2,4.2,0,0,0-1.927-1.138,1.381,1.381,0,0,1-.6-.383.889.889,0,0,1-.226-.611,1.05,1.05,0,0,1,.35-.823.834.834,0,0,1,.8-.2,6.254,6.254,0,0,1,3.068,1.7,6.359,6.359,0,0,1,1.715,3.081.817.817,0,0,1-.222.8,1.107,1.107,0,0,1-.846.349Zm5.139,11.885a18.27,18.27,0,0,1-7.7-1.782,24.5,24.5,0,0,1-7.105-5.026,24.682,24.682,0,0,1-5.017-7.105A18.226,18.226,0,0,1,140-826.909a1.4,1.4,0,0,1,.407-1.026,1.373,1.373,0,0,1,1.016-.411h4.421a1.354,1.354,0,0,1,.905.335,1.473,1.473,0,0,1,.5.827l.777,3.988a2.281,2.281,0,0,1-.034.954,1.419,1.419,0,0,1-.412.67l-3.13,3.047a18.8,18.8,0,0,0,1.727,2.618,25.782,25.782,0,0,0,2.1,2.358,23.352,23.352,0,0,0,2.372,2.072,23.84,23.84,0,0,0,2.714,1.78l3.042-3.068a1.727,1.727,0,0,1,.77-.467,2.214,2.214,0,0,1,.939-.065l3.764.767a1.592,1.592,0,0,1,.838.524,1.335,1.335,0,0,1,.324.881v4.395a1.373,1.373,0,0,1-.411,1.016,1.4,1.4,0,0,1-1.023.41Zm-18.117-15.143,2.419-2.315a.242.242,0,0,0,.085-.143.316.316,0,0,0-.007-.169l-.589-3.033a.28.28,0,0,0-.091-.156.263.263,0,0,0-.169-.052h-2.9a.177.177,0,0,0-.131.053.177.177,0,0,0-.051.131,17.3,17.3,0,0,0,.455,2.822,17.24,17.24,0,0,0,.979,2.865Zm11.792,11.713a13.944,13.944,0,0,0,2.81.96,15.969,15.969,0,0,0,2.736.394.176.176,0,0,0,.131-.052.177.177,0,0,0,.052-.131v-2.851a.263.263,0,0,0-.053-.169.28.28,0,0,0-.156-.091l-2.847-.583a.213.213,0,0,0-.136-.006.336.336,0,0,0-.124.085l-2.414,2.44ZM143.487-820.448ZM155.283-808.735Z"
          transform="translate(60.477 837.971)"
          fill="#222"
          stroke="#222"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  );
};

export const CallReject = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
    >
      <g id="Icon_Reject" transform="translate(-888 -819)">
        <g
          id="Rectangle_159410"
          data-name="Rectangle 159410"
          transform="translate(889 819)"
          fill="#d31510"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="20" height="20" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
        </g>
        <path
          id="call_end_20dp_E8EAED_FILL0_wght400_GRAD0_opsz20"
          d="M47.85-639.62l-2-2.025a1.2,1.2,0,0,1-.367-.848,1.114,1.114,0,0,1,.342-.848,14.824,14.824,0,0,1,4.734-3.405A14.048,14.048,0,0,1,56.483-648a14.048,14.048,0,0,1,5.924,1.253,14.824,14.824,0,0,1,4.734,3.405,1.114,1.114,0,0,1,.342.848,1.2,1.2,0,0,1-.367.848l-2,2.025a1.291,1.291,0,0,1-.709.354,1.123,1.123,0,0,1-.861-.228l-2.911-2.076a1.342,1.342,0,0,1-.367-.443,1.143,1.143,0,0,1-.139-.535v-3.072a12.09,12.09,0,0,0-1.791-.418,12.184,12.184,0,0,0-1.855-.139,12.184,12.184,0,0,0-1.855.139,12.09,12.09,0,0,0-1.791.418v3.072a1.143,1.143,0,0,1-.139.535,1.342,1.342,0,0,1-.367.443l-2.911,2.076a1.1,1.1,0,0,1-.873.215A1.324,1.324,0,0,1,47.85-639.62Zm3.164-5.342a12.1,12.1,0,0,0-1.81,1.089,17.2,17.2,0,0,0-1.658,1.367l1.24,1.241,2.228-1.595Zm10.936,0v2.1l2.228,1.595,1.24-1.241a14.867,14.867,0,0,0-1.646-1.38A11.625,11.625,0,0,0,61.951-644.962ZM51.015-644.962ZM61.951-644.962Z"
          transform="translate(842.517 1472.625)"
          fill="#d31510"
        />
      </g>
    </svg>
  );
};

export const CallAccept = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g id="Icon_Accept" transform="translate(-963 -779)">
        <g
          id="Rectangle_159410"
          data-name="Rectangle 159410"
          transform="translate(963 779)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="15" fill="none" />
        </g>
        <path
          id="call_20dp_E8EAED_FILL0_wght400_GRAD0_opsz20"
          d="M158.493-800.03a15.574,15.574,0,0,1-5.462-1.416,16.13,16.13,0,0,1-4.629-3.249,15.8,15.8,0,0,1-3.225-4.617,16.175,16.175,0,0,1-1.416-5.45,1.078,1.078,0,0,1,.293-.869,1.107,1.107,0,0,1,.85-.369h3.237a1.057,1.057,0,0,1,.7.25,1.176,1.176,0,0,1,.393.631l.571,2.523a1.362,1.362,0,0,1-.036.6,1.091,1.091,0,0,1-.274.476l-2.309,2.333a13.291,13.291,0,0,0,1.095,1.737,12.875,12.875,0,0,0,1.38,1.57,14.234,14.234,0,0,0,1.524,1.321,12.739,12.739,0,0,0,1.714,1.083l2.356-2.285a1.091,1.091,0,0,1,.476-.274,1.363,1.363,0,0,1,.6-.036l2.547.547a1.249,1.249,0,0,1,.643.417,1.09,1.09,0,0,1,.238.7v3.237a1.092,1.092,0,0,1-.381.85A1.113,1.113,0,0,1,158.493-800.03ZM146.4-810.859l1.666-1.666-.408-1.761h-2.138a15.163,15.163,0,0,0,.333,1.749A13.348,13.348,0,0,0,146.4-810.859Zm8.187,8.188a11.193,11.193,0,0,0,1.7.538q.868.2,1.748.318v-2.142l-1.785-.381ZM146.4-810.859ZM154.59-802.672Z"
          transform="translate(819.246 1595.023)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const AlertCircleIcon = ({
  color = "#464646",
  fill = "#fff",
  title = "Alert",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="14"
      viewBox="0 0 18 18"
      width="18"
    >
      <title>{title}</title>
      <rect id="Canvas" fill="none" opacity="0" width="18" height="18" />
      <circle cx="9" cy="9" r="8" fill={color} stroke={color} />
      <path
        d="M7.7,3.3875A.35552.35552,0,0,1,7.8685,3.05,3.12313,3.12313,0,0,1,8.981,2.821a3.4307,3.4307,0,0,1,1.116.172.38849.38849,0,0,1,.2.3435v1.225c0,1.4425-.2885,5.4455-.3415,5.9735a.26351.26351,0,0,1-.26528.26171L9.662,10.795H8.3a.284.284,0,0,1-.289-.2365c-.05-.682-.311-4.55-.311-5.9455ZM9,14.425a1.287,1.287,0,0,1-1.4-1.3155,1.33,1.33,0,0,1,1.308-1.35167q.046-.00076.092.00167a1.316,1.316,0,0,1,1.3978,1.22877q.00389.06054.0022.12123A1.287,1.287,0,0,1,9,14.425Z"
        fill={fill}
      />
    </svg>
  );
};

export const EnvelopePlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g
        id="New_Case_Icon"
        data-name="New Case Icon"
        transform="translate(1163 12553)"
      >
        <rect
          id="Canvas"
          width="28"
          height="28"
          transform="translate(-1163 -12553)"
          fill="#222"
          opacity="0"
        />
        <g
          id="Group_173293"
          data-name="Group 173293"
          transform="translate(-138 -44.771)"
        >
          <path
            id="attach_file_add_20dp_E8EAED_FILL0_wght300_GRAD0_opsz20"
            d="M274.71-820.629a.922.922,0,0,1-.678-.275.923.923,0,0,1-.275-.68v-2.73H271.02a.928.928,0,0,1-.683-.275.924.924,0,0,1-.276-.681.921.921,0,0,1,.276-.68.928.928,0,0,1,.683-.275h2.737v-2.73a.924.924,0,0,1,.276-.681.925.925,0,0,1,.679-.274.916.916,0,0,1,.676.274.929.929,0,0,1,.273.681v2.73h2.719a.943.943,0,0,1,.683.273.9.9,0,0,1,.28.676.919.919,0,0,1-.275.677.924.924,0,0,1-.68.274h-2.73v2.73a.946.946,0,0,1-.273.686A.9.9,0,0,1,274.71-820.629Z"
            transform="translate(-1277.344 -11662.829)"
            fill="#222"
            stroke="#222"
            strokeWidth="0.4"
          />
          <path
            id="outgoing_mail_20dp_E8EAED_FILL0_wght300_GRAD0_opsz20"
            d="M108.351-787.428a2.264,2.264,0,0,1-1.66-.691,2.264,2.264,0,0,1-.691-1.66v-13.869a2.264,2.264,0,0,1,.691-1.661,2.264,2.264,0,0,1,1.66-.691h17.363a2.277,2.277,0,0,1,1.682.691,2.273,2.273,0,0,1,.685,1.661l.037,6.508a.98.98,0,0,1-.29.672.882.882,0,0,1-.667.315.938.938,0,0,1-.686-.3.949.949,0,0,1-.3-.69v-5.609l-9.14,6.462-9.14-6.476v12.984a.438.438,0,0,0,.126.324.438.438,0,0,0,.324.126h10.731a.923.923,0,0,1,.677.271.909.909,0,0,1,.273.672.932.932,0,0,1-.273.679.91.91,0,0,1-.677.279Zm.97-16.671,7.72,5.532,7.748-5.532Zm-1.42,14.77v0Z"
            transform="translate(-1130 -11699)"
            fill="#222"
            stroke="#222"
            strokeWidth="0.4"
          />
        </g>
      </g>
    </svg>
  );
};
export const NoChatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
    >
      <g
        id="Decorative_icon"
        data-name="Decorative icon"
        transform="translate(0.5)"
      >
        <rect
          id="Placement_Area"
          data-name="Placement Area"
          width="48"
          height="48"
          transform="translate(0)"
          fill="red"
          opacity="0"
        />
        <path
          id="chat_error_24dp_E8EAED_FILL0_wght200_GRAD0_opsz24"
          d="M144-819.446l6.041,5.989a1.162,1.162,0,0,0,.917.349,1.34,1.34,0,0,0,.918-.4,1.217,1.217,0,0,0,.375-.892,1.217,1.217,0,0,0-.375-.892l-5.989-6.041,5.989-6.041a1.162,1.162,0,0,0,.349-.917,1.34,1.34,0,0,0-.4-.918,1.217,1.217,0,0,0-.892-.375,1.217,1.217,0,0,0-.892.375L144-823.221l-6.041-5.989a1.162,1.162,0,0,0-.917-.349,1.34,1.34,0,0,0-.918.4,1.217,1.217,0,0,0-.375.892,1.217,1.217,0,0,0,.375.892l5.989,6.041-5.989,6.041a1.162,1.162,0,0,0-.349.917,1.34,1.34,0,0,0,.4.918,1.217,1.217,0,0,0,.892.375,1.217,1.217,0,0,0,.892-.375Zm-15.795,16.779-4.544,4.543a1.984,1.984,0,0,1-2.336.465A1.984,1.984,0,0,1,120-799.646v-36.046a4.173,4.173,0,0,1,1.233-3.075A4.173,4.173,0,0,1,124.308-840h39.384a4.173,4.173,0,0,1,3.075,1.233A4.173,4.173,0,0,1,168-835.692v28.717a4.173,4.173,0,0,1-1.233,3.075,4.173,4.173,0,0,1-3.075,1.233Zm-1.139-2.667h36.625a1.569,1.569,0,0,0,1.129-.513,1.569,1.569,0,0,0,.513-1.129v-28.717a1.569,1.569,0,0,0-.513-1.129,1.568,1.568,0,0,0-1.129-.513H124.308a1.568,1.568,0,0,0-1.129.513,1.569,1.569,0,0,0-.513,1.129v34.743Zm-4.4,0v0Z"
          transform="translate(-120 844)"
          fill="#747474"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export const NoNotesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45.072"
      height="48.25"
      viewBox="0 0 45.072 48.25"
    >
      <g
        id="Icon_Empty_Notes"
        data-name="Icon_Empty Notes"
        transform="translate(-1128 -260.531)"
      >
        <path
          id="Subtraction_1"
          data-name="Subtraction 1"
          d="M28.47,45.292H4.135a3.985,3.985,0,0,1-2.921-1.21A3.991,3.991,0,0,1,0,41.155V8.771A3.991,3.991,0,0,1,1.214,5.845a3.985,3.985,0,0,1,2.921-1.21H15.781a4.325,4.325,0,0,1,1.231-3.229A4.344,4.344,0,0,1,20.329,0a4.391,4.391,0,0,1,3.346,1.405,4.261,4.261,0,0,1,1.2,3.229H36.526a4.139,4.139,0,0,1,4.135,4.137V31.584H37.312V8.771a.845.845,0,0,0-.787-.792H4.135a.739.739,0,0,0-.54.247.749.749,0,0,0-.251.546V41.155A.752.752,0,0,0,3.6,41.7a.74.74,0,0,0,.54.247H28.47v3.343ZM20.329,3.6a1.5,1.5,0,0,0-1.107.434,1.522,1.522,0,0,0-.439,1.107,1.508,1.508,0,0,0,.439,1.107,1.546,1.546,0,0,0,2.652-1.107A1.494,1.494,0,0,0,20.329,3.6ZM11.347,36.326H10a.983.983,0,0,1-1.036-1.035v-1.37a1.855,1.855,0,0,1,.172-.824,2.42,2.42,0,0,1,.46-.653l14.39-14.385L27.233,21.3,12.84,35.693a2.135,2.135,0,0,1-.67.478A2.067,2.067,0,0,1,11.347,36.326ZM29.223,19.318h0l-3.245-3.248,1.967-2.019a1.423,1.423,0,0,1,2.189,0l1.108,1.107a1.424,1.424,0,0,1,0,2.19l-2.019,1.97Z"
          transform="translate(1128 260.531)"
          fill="#747474"
        />
        <path
          id="Path_26462"
          data-name="Path 26462"
          d="M176.679-787.04l-3.635,3.684a1.254,1.254,0,0,1-.867.412,1.214,1.214,0,0,1-.886-.412,1.265,1.265,0,0,1-.422-.9,1.265,1.265,0,0,1,.422-.9l3.635-3.635-3.683-3.683a1.252,1.252,0,0,1-.412-.868,1.212,1.212,0,0,1,.412-.886,1.263,1.263,0,0,1,.9-.422,1.264,1.264,0,0,1,.9.422l3.635,3.635,3.684-3.684a1.274,1.274,0,0,1,.892-.412,1.238,1.238,0,0,1,.911.412,1.265,1.265,0,0,1,.422.9,1.266,1.266,0,0,1-.422.9l-3.683,3.683,3.635,3.635a1.359,1.359,0,0,1,.437.868,1.128,1.128,0,0,1-.388.886,1.264,1.264,0,0,1-.9.422,1.263,1.263,0,0,1-.9-.422Z"
          transform="translate(990.236 1091.475)"
          fill="#747474"
          stroke="#747474"
          strokeWidth="0.5"
        />
        <path
          id="Path_26465"
          data-name="Path 26465"
          d="M1.675,0A1.675,1.675,0,1,1,0,1.675,1.675,1.675,0,0,1,1.675,0Z"
          transform="translate(1165.31 290.627)"
          fill="#747474"
        />
        <path
          id="Path_26466"
          data-name="Path 26466"
          d="M1.675,0A1.675,1.675,0,1,1,0,1.675,1.675,1.675,0,0,1,1.675,0Z"
          transform="translate(1154.93 302.474)"
          fill="#747474"
        />
      </g>
    </svg>
  );
};
export const AttachIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="Attach_Icon" transform="translate(-0.131)">
        <rect
          id="Placement_Area"
          data-name="Placement Area"
          width="32"
          height="32"
          transform="translate(0.131)"
          fill="red"
          opacity="0"
        />
        <g
          id="Background"
          transform="translate(0.131)"
          fill="rgba(255,255,255,0)"
          stroke="rgba(255,255,255,0)"
          strokeWidth="1"
        >
          <rect width="32" height="32" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="none" />
        </g>
        <g id="Icon" transform="translate(7 6.999)">
          <rect
            id="Canvas"
            width="18"
            height="18"
            transform="translate(0.131 0.001)"
            fill="#222"
            opacity="0"
          />
          <path
            id="Path_13047"
            data-name="Path 13047"
            d="M8.1,15.778a3.32,3.32,0,0,1-2.364.985H5.687a3.488,3.488,0,0,1-2.414-1.037,3.382,3.382,0,0,1-.1-4.782l.048-.049L12.112,2a2.437,2.437,0,0,1,1.567-.74,1.86,1.86,0,0,1,1.521.56,1.769,1.769,0,0,1,.559,1.534,2.87,2.87,0,0,1-.792,1.5l-5.93,5.92c-.382.382-.741.658-1.15.25s-.088-.7845.263-1.1355c.1335-.1335,4.124-4.119,4.8365-4.8295a.366.366,0,0,0,.007-.5105l-.3375-.359a.3675.3675,0,0,0-.51948-.01578L12.127,4.1785,7.15,9.172a1.816,1.816,0,0,0-.036,2.7345c1.3305,1.33,2.8415-.2955,2.8415-.2955L15.85,5.733a3.30462,3.30462,0,0,0,.236-4.8A3.1135,3.1135,0,0,0,13.7945,0a3.6375,3.6375,0,0,0-2.566,1.1135L2.38,9.95a4.7165,4.7165,0,0,0,6.67,6.67l7.7025-7.7a.36749.36749,0,0,0,0-.519l-.375-.3755a.3675.3675,0,0,0-.5195,0Z"
            transform="translate(0 0.001)"
            fill="#222"
          />
        </g>
      </g>
    </svg>
  );
};

export const SendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="Send_Icon" transform="translate(-0.131)">
        <rect
          id="Placement_Area"
          data-name="Placement Area"
          width="48"
          height="48"
          transform="translate(0.131)"
          fill="red"
          opacity="0"
        />
        <g
          id="Background"
          transform="translate(0.131)"
          fill="#fdfdfd"
          stroke="#b1b1b1"
          strokeWidth="1"
        >
          <rect width="48" height="48" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="47" height="47" rx="3.5" fill="none" />
        </g>
        <g id="Icon" transform="translate(13 13)">
          <rect
            id="Canvas"
            width="22"
            height="22"
            transform="translate(0.131)"
            fill="#222"
            opacity="0"
          />
          <path
            id="Path_13080"
            data-name="Path 13080"
            d="M20.123,2.556.94,8.28a.306.306,0,0,0-.049.566l4.841,2.416Z"
            transform="translate(0.16 0.568)"
            fill="#222"
          />
          <path
            id="Path_13081"
            data-name="Path 13081"
            d="M6.544,12.146l7.295,3.667a.611.611,0,0,0,.82-.272h0L20.323,3.182Z"
            transform="translate(1.454 0.707)"
            fill="#222"
          />
          <path
            id="Path_13082"
            data-name="Path 13082"
            d="M5.04,11.625v4.668a.436.436,0,0,0,.717.332l3.276-2.76Z"
            transform="translate(1.12 2.583)"
            fill="#222"
          />
        </g>
      </g>
    </svg>
  );
};

export const CannedResponsesIcon = () => {
  return (
    <svg
      id="Predefined_Content_Icon"
      data-name="Predefined Content Icon"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="32"
        height="32"
        fill="red"
        opacity="0"
      />
      <g
        id="Background"
        fill="rgba(255,255,255,0)"
        stroke="rgba(255,255,255,0)"
        strokeWidth="1"
      >
        <rect width="32" height="32" rx="4" stroke="none" />
        <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="none" />
      </g>
      <g id="Icon" transform="translate(7 7)">
        <rect id="Canvas" width="18" height="18" fill="#222" opacity="0" />
        <path
          id="Path_13063"
          data-name="Path 13063"
          d="M9.891,14H5a2,2,0,0,1,0-4h5.261a.5.5,0,0,0,.4-.2l5.55-7.4a.25.25,0,0,0-.2-.4h-8a.5.5,0,0,0-.4.2L1.761,9.664A3.99,3.99,0,0,0,4.984,16h5.275a.5.5,0,0,0,.4-.2l5.55-7.4a.25.25,0,0,0-.2-.4H14.391Z"
          fill="#222"
        />
      </g>
    </svg>
  );
};

export const ChatTransferIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
    >
      <g id="TRansffer" transform="translate(-10 -7)">
        <rect
          id="Canvas"
          width="18"
          height="18"
          transform="translate(10 7)"
          fill="#222"
          opacity="0"
        />
        <path
          id="chat_paste_go_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M143.772-778.022h-3.346a.643.643,0,0,1-.474-.191.644.644,0,0,1-.191-.474.643.643,0,0,1,.191-.474.644.644,0,0,1,.474-.191h3.346l-1.152-1.16a.7.7,0,0,1-.19-.47.614.614,0,0,1,.19-.47.638.638,0,0,1,.466-.2.648.648,0,0,1,.469.2l2.2,2.2a.77.77,0,0,1,.241.561.769.769,0,0,1-.241.561l-2.2,2.2a.648.648,0,0,1-.469.2.638.638,0,0,1-.466-.2.614.614,0,0,1-.19-.47.7.7,0,0,1,.19-.47Zm-11.425,0-1.663,1.663a.376.376,0,0,1-.438.095.369.369,0,0,1-.245-.374V-788.4a1.544,1.544,0,0,1,.471-1.133A1.545,1.545,0,0,1,131.6-790h10.545a1.545,1.545,0,0,1,1.133.471,1.545,1.545,0,0,1,.471,1.133v3.72a.644.644,0,0,1-.191.474.645.645,0,0,1-.474.191.643.643,0,0,1-.474-.191.644.644,0,0,1-.191-.474v-3.72a.266.266,0,0,0-.077-.2.266.266,0,0,0-.2-.077H131.6a.266.266,0,0,0-.2.077.266.266,0,0,0-.077.2v9.043H137.1a.644.644,0,0,1,.474.191.644.644,0,0,1,.191.474.643.643,0,0,1-.191.474.644.644,0,0,1-.474.191Zm1.7-7.1h5.665a.644.644,0,0,0,.474-.191.644.644,0,0,0,.191-.474.643.643,0,0,0-.191-.474.645.645,0,0,0-.474-.191h-5.665a.644.644,0,0,0-.474.191.644.644,0,0,0-.191.474.643.643,0,0,0,.191.474A.644.644,0,0,0,134.044-785.12Zm0,3.549h3a.644.644,0,0,0,.474-.191.644.644,0,0,0,.191-.474.643.643,0,0,0-.191-.474.644.644,0,0,0-.474-.191h-3a.644.644,0,0,0-.474.191.644.644,0,0,0-.191.474.643.643,0,0,0,.191.474A.645.645,0,0,0,134.044-781.571Zm-2.713,2.218v0Z"
          transform="translate(-117 798.862)"
          fill="#222"
        />
      </g>
    </svg>
  );
};

export const NewIncomingChat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g
        id="New_Incoming_Chat"
        data-name="New_Incoming Chat"
        transform="translate(-198 -7)"
      >
        <rect
          id="Canvas"
          width="28"
          height="28"
          transform="translate(198 7)"
          fill="#222"
          opacity="0"
        />
        <path
          id="chat_add_on_20dp_E8EAED_FILL0_wght300_GRAD0_opsz20"
          d="M157.626-789.406l-2.673,2.673a.531.531,0,0,1-.592.107.468.468,0,0,1-.361-.47v-16.686a2.134,2.134,0,0,1,.648-1.576,2.134,2.134,0,0,1,1.558-.643h14.662a2.107,2.107,0,0,1,1.552.648,2.132,2.132,0,0,1,.643,1.557v5.647a.8.8,0,0,1-.285.589.9.9,0,0,1-.63.268.84.84,0,0,1-.607-.256.855.855,0,0,1-.261-.635V-803.8a.411.411,0,0,0-.119-.3.411.411,0,0,0-.3-.119H156.2a.411.411,0,0,0-.3.119.411.411,0,0,0-.119.3v12.607h9.286a.852.852,0,0,1,.607.285.875.875,0,0,1,.285.63.8.8,0,0,1-.285.607.887.887,0,0,1-.607.261Zm1.937-9.874h7.925a.883.883,0,0,0,.64-.254.844.844,0,0,0,.261-.63.876.876,0,0,0-.256-.637.852.852,0,0,0-.634-.261h-7.925a.883.883,0,0,0-.64.254.844.844,0,0,0-.261.63.876.876,0,0,0,.256.637A.852.852,0,0,0,159.564-799.28Zm0,4.937h4.642a.866.866,0,0,0,.635-.254.853.853,0,0,0,.256-.63.875.875,0,0,0-.256-.637.855.855,0,0,0-.635-.261h-4.642a.867.867,0,0,0-.635.254.853.853,0,0,0-.256.63.875.875,0,0,0,.256.637A.855.855,0,0,0,159.565-794.343ZM172.514-789H169.7a.86.86,0,0,1-.635-.258.862.862,0,0,1-.256-.634.854.854,0,0,1,.256-.631.865.865,0,0,1,.635-.254h2.811v-2.8a.88.88,0,0,1,.254-.638.844.844,0,0,1,.63-.262.861.861,0,0,1,.633.256.861.861,0,0,1,.257.635v2.811h2.817a.866.866,0,0,1,.637.256.862.862,0,0,1,.257.635.86.86,0,0,1-.257.635.867.867,0,0,1-.637.256h-2.817v2.811a.86.86,0,0,1-.257.635.853.853,0,0,1-.626.256.86.86,0,0,1-.635-.257.867.867,0,0,1-.256-.637Zm-16.731-2.186v0Z"
          transform="translate(47 817)"
          fill="#222"
          stroke="#222"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  );
};

export const DownloadIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Download_Icon" transform="translate(-1389 -626)">
        <g
          id="Rectangle_137320"
          data-name="Rectangle 137320"
          transform="translate(1389 626)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <g
          id="Decorative_icon"
          data-name="Decorative icon"
          transform="translate(1392 629)"
        >
          <rect
            id="Placement_Area"
            data-name="Placement Area"
            width="18"
            height="18"
            fill={color}
            opacity="0"
          />
          <g id="Icon">
            <rect id="Canvas" width="18" height="18" fill={color} opacity="0" />
            <path
              id="Path_13182"
              data-name="Path 13182"
              d="M16.5,12h-1a.5.5,0,0,0-.5.5V15H3V12.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-4A.5.5,0,0,0,16.5,12Z"
              transform="translate(0 0)"
              fill={color}
            />
            <path
              id="Path_13183"
              data-name="Path 13183"
              d="M8.825,13.428a.25.25,0,0,0,.35,0L12.9,9.666A.391.391,0,0,0,13,9.4a.4.4,0,0,0-.4-.4H10V1.5A.5.5,0,0,0,9.5,1h-1a.5.5,0,0,0-.5.5V9H5.4a.4.4,0,0,0-.4.4.391.391,0,0,0,.1.263Z"
              transform="translate(0 0)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DefaultImageIcon = () => {
  return (
    <svg
      id="IMg_ICon"
      data-name="IMg ICon"
      xmlns="http://www.w3.org/2000/svg"
      width="24.001"
      height="24"
      viewBox="0 0 24.001 24"
    >
      <rect
        id="Placement_Area"
        data-name="Placement Area"
        width="24"
        height="24"
        fill="#fff"
        opacity="0"
      />
      <g id="Icon" transform="translate(-1.555 -1.667)">
        <path
          id="Path_13180"
          data-name="Path 13180"
          d="M24.25,3H1.75A.75.75,0,0,0,1,3.75v16.5a.75.75,0,0,0,.75.75h22.5a.75.75,0,0,0,.75-.75V3.75A.75.75,0,0,0,24.25,3ZM23.5,17.53l-3.954-3.955a1.5,1.5,0,0,0-2.121,0l-2.3,2.3L9.454,10.211a1.5,1.5,0,0,0-2.121,0L2.5,15.044V4.5h21Z"
          transform="translate(0.556 1.667)"
          fill="#323232"
        />
        <circle
          id="Ellipse_119"
          data-name="Ellipse 119"
          cx="2.025"
          cy="2.025"
          r="2.025"
          transform="translate(18.056 8.117)"
          fill="#323232"
        />
      </g>
    </svg>
  );
};

export const DefaultEyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Eye_Icon" transform="translate(-1429 -626)">
        <g
          id="Rectangle_137321"
          data-name="Rectangle 137321"
          transform="translate(1429 626)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="visibility_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24"
          d="M60-789.93a3.642,3.642,0,0,0,2.675-1.1,3.642,3.642,0,0,0,1.1-2.675,3.642,3.642,0,0,0-1.1-2.675,3.642,3.642,0,0,0-2.675-1.1,3.642,3.642,0,0,0-2.675,1.1,3.642,3.642,0,0,0-1.1,2.675,3.642,3.642,0,0,0,1.1,2.675A3.642,3.642,0,0,0,60-789.93Zm0-1.51a2.184,2.184,0,0,1-1.6-.661,2.185,2.185,0,0,1-.661-1.6,2.185,2.185,0,0,1,.661-1.6,2.185,2.185,0,0,1,1.6-.661,2.185,2.185,0,0,1,1.6.661,2.185,2.185,0,0,1,.661,1.6,2.185,2.185,0,0,1-.661,1.6A2.184,2.184,0,0,1,60-791.441Zm0,4.028a9.2,9.2,0,0,1-5.129-1.51,10.851,10.851,0,0,1-3.661-3.986,1.675,1.675,0,0,1-.157-.388,1.6,1.6,0,0,1-.052-.409,1.6,1.6,0,0,1,.052-.409,1.678,1.678,0,0,1,.157-.388,10.85,10.85,0,0,1,3.661-3.986A9.2,9.2,0,0,1,60-800a9.2,9.2,0,0,1,5.129,1.511A10.85,10.85,0,0,1,68.79-794.5a1.677,1.677,0,0,1,.157.388,1.6,1.6,0,0,1,.052.409,1.6,1.6,0,0,1-.052.409,1.673,1.673,0,0,1-.157.388,10.851,10.851,0,0,1-3.661,3.986A9.2,9.2,0,0,1,60-787.413ZM60-793.706Zm0,4.615a8.01,8.01,0,0,0,4.353-1.248,8.2,8.2,0,0,0,3.031-3.367,8.2,8.2,0,0,0-3.031-3.367A8.009,8.009,0,0,0,60-798.322a8.009,8.009,0,0,0-4.353,1.248,8.2,8.2,0,0,0-3.031,3.367,8.2,8.2,0,0,0,3.031,3.367A8.01,8.01,0,0,0,60-789.091Z"
          transform="translate(1381 1431.706)"
          fill="#0265dc"
        />
      </g>
    </svg>
  );
};

export const WarningIconSidebar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g id="Icon" transform="translate(-16 -15)">
        <rect
          id="Frame"
          width="20"
          height="20"
          transform="translate(16 15)"
          fill="#d7373f"
          opacity="0"
        />
        <path
          id="Shape"
          d="M9.5,1.317.207,17.947a.556.556,0,0,0,.484.827H19.278a.556.556,0,0,0,.556-.556.549.549,0,0,0-.071-.271L10.469,1.317a.556.556,0,0,0-.969,0Zm1.6,14.957a.278.278,0,0,1-.278.278H9.152a.278.278,0,0,1-.278-.278V14.607a.278.278,0,0,1,.278-.278h1.667a.278.278,0,0,1,.278.278Zm0-3.333a.278.278,0,0,1-.278.278H9.152a.278.278,0,0,1-.278-.278V6.274A.278.278,0,0,1,9.152,6h1.667a.278.278,0,0,1,.278.278Z"
          transform="translate(16.015 15.115)"
          fill="#d7373f"
        />
      </g>
    </svg>
  );
};

export const MissedChatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14.957"
      viewBox="0 0 16 14.957"
    >
      <g id="Icon_MissedChat" transform="translate(-1345 -336)">
        <path
          id="Path_26412"
          data-name="Path 26412"
          d="M99-851l-1.727,1.727a.684.684,0,0,1-.815.161.7.7,0,0,1-.458-.7V-862.5a1.444,1.444,0,0,1,.441-1.059A1.444,1.444,0,0,1,97.5-864h13a1.444,1.444,0,0,1,1.059.441A1.444,1.444,0,0,1,112-862.5v10a1.444,1.444,0,0,1-.441,1.059A1.444,1.444,0,0,1,110.5-851Zm-.625-1.5H110.5v-10h-13v10.875Zm-.875,0v0Z"
          transform="translate(1249 1200)"
          fill="#d7373f"
        />
        <path
          id="Path_26413"
          data-name="Path 26413"
          d="M144.875-673.5v1.568a.426.426,0,0,1-.125.313.42.42,0,0,1-.31.126.428.428,0,0,1-.313-.126.42.42,0,0,1-.128-.311v-2.623a.43.43,0,0,1,.126-.313.42.42,0,0,1,.312-.128h2.623a.431.431,0,0,1,.313.125.417.417,0,0,1,.128.31.429.429,0,0,1-.125.313.418.418,0,0,1-.311.128H145.5l2.59,2.59,3.158-3.158a.431.431,0,0,1,.314-.137.445.445,0,0,1,.316.134.435.435,0,0,1,.128.31.432.432,0,0,1-.138.314l-3.153,3.153a.85.85,0,0,1-.3.2.907.907,0,0,1-.328.061.907.907,0,0,1-.328-.061.836.836,0,0,1-.292-.194Z"
          transform="translate(1205.5 1015.5)"
          fill="#d7373f"
          stroke="#d7373f"
          strokeWidth="0.4"
        />
      </g>
    </svg>
  );
};

export const MissedCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g id="PhoneMissed_Icon" transform="translate(-376 -239)">
        <g
          id="Rectangle_137277"
          data-name="Rectangle 137277"
          transform="translate(376 239)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="15" fill="none" />
        </g>
        <path
          id="phone_missed_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M48.049-807.988l-1.407-1.37a.7.7,0,0,1-.225-.527.745.745,0,0,1,.232-.534,10.32,10.32,0,0,1,3.592-2.459,10.883,10.883,0,0,1,4.175-.848,10.848,10.848,0,0,1,4.17.848,10.446,10.446,0,0,1,3.6,2.459.745.745,0,0,1,.232.534.7.7,0,0,1-.225.527l-1.407,1.37a.818.818,0,0,1-.5.243.729.729,0,0,1-.514-.148L57.913-809.3a.932.932,0,0,1-.271-.308.814.814,0,0,1-.088-.381v-2.082a10.835,10.835,0,0,0-1.56-.407,8.92,8.92,0,0,0-1.577-.136,8.92,8.92,0,0,0-1.577.136,10.835,10.835,0,0,0-1.56.407v2.082a.814.814,0,0,1-.088.381.932.932,0,0,1-.271.308l-1.857,1.411a.729.729,0,0,1-.514.148A.818.818,0,0,1,48.049-807.988Zm2.125-3.727a9.131,9.131,0,0,0-1.282.754,12.52,12.52,0,0,0-1.154.913.1.1,0,0,0-.035.071.1.1,0,0,0,.035.071l.809.8a.169.169,0,0,0,.089.046.11.11,0,0,0,.1-.025l1.357-1.04a.251.251,0,0,0,.06-.071.156.156,0,0,0,.025-.078Zm8.487.023v1.419a.157.157,0,0,0,.025.078.251.251,0,0,0,.06.071l1.357,1.04a.11.11,0,0,0,.1.025.169.169,0,0,0,.089-.046l.809-.779a.1.1,0,0,0,.035-.071.1.1,0,0,0-.035-.071,10.091,10.091,0,0,0-1.154-.93A8.651,8.651,0,0,0,58.661-811.693ZM50.173-811.73ZM58.661-811.707Zm-8.481-4.234a.535.535,0,0,1-.394-.159.536.536,0,0,1-.159-.394v-2.839a.645.645,0,0,1,.192-.475.645.645,0,0,1,.475-.192h2.839a.535.535,0,0,1,.394.159.536.536,0,0,1,.159.394.535.535,0,0,1-.159.394.535.535,0,0,1-.394.159H51.512l2.715,2.715a.221.221,0,0,0,.163.064.221.221,0,0,0,.163-.064l3.5-3.5a.547.547,0,0,1,.391-.168.534.534,0,0,1,.4.168.542.542,0,0,1,.172.394.542.542,0,0,1-.172.394l-3.493,3.493a1.282,1.282,0,0,1-.945.382,1.285,1.285,0,0,1-.946-.382l-2.722-2.722v1.621a.536.536,0,0,1-.159.394A.536.536,0,0,1,50.18-815.941Z"
          transform="translate(329.583 1060.871)"
          fill="#d7373f"
        />
      </g>
    </svg>
  );
};

export const MissedCaseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="11.178"
      viewBox="0 0 16 11.178"
    >
      <g
        id="Case_Missed"
        data-name="Case Missed"
        transform="translate(23467 5223.257)"
      >
        <path
          id="phone_missed_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M50.1-816.507a.46.46,0,0,1-.339-.137.461.461,0,0,1-.137-.339v-2.443a.555.555,0,0,1,.165-.409A.555.555,0,0,1,50.2-820h2.443a.461.461,0,0,1,.339.137.462.462,0,0,1,.137.339.461.461,0,0,1-.137.339.461.461,0,0,1-.339.137H51.249l2.337,2.337a.19.19,0,0,0,.141.055.19.19,0,0,0,.141-.055l3.009-3.01a.47.47,0,0,1,.336-.145.459.459,0,0,1,.343.145.467.467,0,0,1,.148.34.466.466,0,0,1-.148.339l-3.006,3.006a1.1,1.1,0,0,1-.813.329,1.106,1.106,0,0,1-.814-.329l-2.343-2.343v1.4a.461.461,0,0,1-.137.339A.461.461,0,0,1,50.1-816.507Z"
          transform="translate(-23508.703 -4396.373)"
          fill="#d7373f"
        />
        <path
          id="Path_26422"
          data-name="Path 26422"
          d="M117.049-748.044l5.517,3.229,5.517-3.229Zm.111,8.731a1.116,1.116,0,0,1-.819-.342,1.122,1.122,0,0,1-.341-.822v-7.368a1.109,1.109,0,0,1,.341-.818,1.122,1.122,0,0,1,.819-.338h10.812a1.117,1.117,0,0,1,.819.341,1.117,1.117,0,0,1,.341.819v4.447a.429.429,0,0,1-.134.321.458.458,0,0,1-.332.13.46.46,0,0,1-.335-.135.449.449,0,0,1-.137-.334v-3.466l-5.313,3.11a1.791,1.791,0,0,1-.319.083.492.492,0,0,1-.157-.024.791.791,0,0,1-.136-.06l-5.331-3.11v6.4a.216.216,0,0,0,.062.16.216.216,0,0,0,.16.062h4.4a.455.455,0,0,1,.334.134.448.448,0,0,1,.135.331.46.46,0,0,1-.135.335.449.449,0,0,1-.334.138ZM122.566-743.23ZM122.566-744.815ZM122.566-743.9Z"
          transform="translate(-23583 -4474.257)"
          fill="#d7373f"
        />
      </g>
    </svg>
  );
};

export const ThreeDotIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 0 18 18"
      width="18"
    >
      <title>Menu</title>
      <rect id="Canvas" fill="#464646" opacity="0" width="18" height="18" />
      <circle fill="#464646" cx="9" cy="13.5" r="1.425" />
      <circle fill="#464646" cx="9" cy="9" r="1.425" />
      <circle fill="#464646" cx="9" cy="4.5" r="1.425" />
    </svg>
  );
};

export const EnvelopeIcon = ({ color = "#666666" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
};

export const NoSpeedDialIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="Icon_NoContact" transform="translate(-756 -381)">
        <rect
          id="Canvas"
          width="48"
          height="48"
          transform="translate(756 381)"
          fill="#747474"
          opacity="0"
        />
        <g
          id="Group_173354"
          data-name="Group 173354"
          transform="translate(96.496 77.001)"
        >
          <path
            id="Path_26444"
            data-name="Path 26444"
            d="M240.945-799.323H215.93a3.782,3.782,0,0,1-2.794-1.144,3.827,3.827,0,0,1-1.135-2.8v-36.784a3.81,3.81,0,0,1,1.145-2.8,3.81,3.81,0,0,1,2.8-1.144h16.22a4.06,4.06,0,0,1,1.5.284,3.866,3.866,0,0,1,1.324.887l8.733,8.734a3.872,3.872,0,0,1,.887,1.324,4.058,4.058,0,0,1,.284,1.5v28a3.811,3.811,0,0,1-1.145,2.8A3.816,3.816,0,0,1,240.945-799.323Zm0-3.192a.717.717,0,0,0,.519-.236.719.719,0,0,0,.237-.519V-831.6l-9.206-9.2H215.946a.718.718,0,0,0-.519.236.72.72,0,0,0-.236.519v36.784a.72.72,0,0,0,.236.519.718.718,0,0,0,.519.236Zm-25.757,0v0Z"
            transform="translate(453 1148)"
            fill="#747474"
          />
          <path
            id="Path_26447"
            data-name="Path 26447"
            d="M226.236-821.76a3.642,3.642,0,0,0,2.692-1.112,3.705,3.705,0,0,0,1.1-2.705,3.638,3.638,0,0,0-1.113-2.692,3.7,3.7,0,0,0-2.7-1.1,3.641,3.641,0,0,0-2.692,1.112,3.706,3.706,0,0,0-1.1,2.706,3.64,3.64,0,0,0,1.113,2.692A3.7,3.7,0,0,0,226.236-821.76ZM218-813.677h16.447v-1.506a3.331,3.331,0,0,0-.642-2.047,4.322,4.322,0,0,0-1.681-1.344,11.574,11.574,0,0,0-2.858-.945,15.907,15.907,0,0,0-3.043-.3,15.9,15.9,0,0,0-3.043.3,11.574,11.574,0,0,0-2.858.945,4.322,4.322,0,0,0-1.681,1.344,3.331,3.331,0,0,0-.642,2.047Z"
            transform="translate(455.099 1149.311)"
            fill="#747474"
          />
          <path
            id="Path_26446"
            data-name="Path 26446"
            d="M-16132.316-1628.922h4.736v9.641l-5.355,5.357h-7.977v-7.579Z"
            transform="translate(16826.592 1965.923)"
            fill="#fff"
          />
          <path
            id="Path_26445"
            data-name="Path 26445"
            d="M177.028-786.583l-3.852,3.9a1.329,1.329,0,0,1-.919.437,1.287,1.287,0,0,1-.939-.437,1.34,1.34,0,0,1-.447-.955,1.34,1.34,0,0,1,.447-.955l3.852-3.852-3.9-3.9a1.327,1.327,0,0,1-.437-.92,1.285,1.285,0,0,1,.437-.939,1.339,1.339,0,0,1,.955-.447,1.34,1.34,0,0,1,.955.447l3.852,3.853,3.9-3.9a1.351,1.351,0,0,1,.945-.437,1.312,1.312,0,0,1,.965.437,1.341,1.341,0,0,1,.447.955,1.341,1.341,0,0,1-.447.955l-3.9,3.9,3.852,3.852a1.441,1.441,0,0,1,.463.92,1.2,1.2,0,0,1-.411.939,1.34,1.34,0,0,1-.955.447,1.339,1.339,0,0,1-.955-.447Z"
            transform="translate(518.717 1133.997)"
            fill="#747474"
          />
          <circle
            id="Ellipse_152"
            data-name="Ellipse 152"
            cx="1.576"
            cy="1.576"
            r="1.576"
            transform="translate(694.741 335.425)"
            fill="#747474"
          />
          <circle
            id="Ellipse_153"
            data-name="Ellipse 153"
            cx="1.576"
            cy="1.576"
            r="1.576"
            transform="translate(684.104 345.529)"
            fill="#747474"
          />
        </g>
      </g>
    </svg>
  );
};

export const speakerIcon1 =
  "data:image/svg+xml;base64," +
  btoa(`
<svg id="Notification_Icon_1" data-name="Notification Icon 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<rect id="Canvas" width="24" height="24" fill="#ff13dc" opacity="0"/>
<path id="Path_26412" data-name="Path 26412" d="M4.5,7.339H.667A.667.667,0,0,0,0,8.006v6.618a.667.667,0,0,0,.667.667H4.5a.952.952,0,0,1,.621.23L9.871,20.36a.485.485,0,0,0,.8-.383V2.624a.484.484,0,0,0-.8-.381L5.119,7.11A.96.96,0,0,1,4.5,7.339Z" transform="translate(0 0.71)" fill="#ad0955"/>
<path id="Path_26413" data-name="Path 26413" d="M11.291,9.971a4.623,4.623,0,0,1-.938,2.795.653.653,0,0,0,.057.859l.011.011a.661.661,0,0,0,.991-.06A5.97,5.97,0,0,0,11.4,6.34a.661.661,0,0,0-.989-.058l-.01.011a.655.655,0,0,0-.057.861A4.629,4.629,0,0,1,11.291,9.971Z" transform="translate(3.402 2.029)" fill="#ad0955"/>
</svg>
`);

export const speakerIcon2 =
  "data:image/svg+xml;base64," +
  btoa(`
<svg id="Notification_Icon_2" data-name="Notification Icon 2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<rect id="Canvas" width="24" height="24" fill="#ff13dc" opacity="0"/>
<path id="Path_26418" data-name="Path 26418" d="M4.5,7.339H.667A.667.667,0,0,0,0,8.006v6.618a.667.667,0,0,0,.667.667H4.5a.952.952,0,0,1,.621.23L9.871,20.36a.485.485,0,0,0,.8-.383V2.624a.484.484,0,0,0-.8-.381L5.119,7.11A.96.96,0,0,1,4.5,7.339Z" transform="translate(0 0.71)" fill="#ad0955"/>
<path id="Path_26419" data-name="Path 26419" d="M11.291,9.971a4.623,4.623,0,0,1-.938,2.795.653.653,0,0,0,.057.859l.011.011a.661.661,0,0,0,.991-.06A5.97,5.97,0,0,0,11.4,6.34a.661.661,0,0,0-.989-.058l-.01.011a.655.655,0,0,0-.057.861A4.629,4.629,0,0,1,11.291,9.971Z" transform="translate(3.402 2.029)" fill="#ad0955"/>
<path id="Path_26420" data-name="Path 26420" d="M14.581,10.681A8.625,8.625,0,0,1,12.5,16.3a.649.649,0,0,0,.042.878l.009.009a.667.667,0,0,0,.943,0q.021-.021.04-.044a9.987,9.987,0,0,0-.017-12.953.667.667,0,0,0-.939-.082l-.04.037-.009.01a.651.651,0,0,0-.045.879A8.625,8.625,0,0,1,14.581,10.681Z" transform="translate(4.113 1.319)" fill="#ad0955"/>
</svg>

`);

export const speakerIcon3 =
  "data:image/svg+xml;base64," +
  btoa(`
<svg id="Notification_Icon_3" data-name="Notification Icon 3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<rect id="Canvas" width="24" height="24" fill="#ff13dc" opacity="0"/>
<path id="Path_26414" data-name="Path 26414" d="M4.5,7.339H.667A.667.667,0,0,0,0,8.006v6.618a.667.667,0,0,0,.667.667H4.5a.952.952,0,0,1,.621.23L9.871,20.36a.485.485,0,0,0,.8-.383V2.624a.484.484,0,0,0-.8-.381L5.119,7.11A.96.96,0,0,1,4.5,7.339Z" transform="translate(0 0.71)" fill="#ad0955"/>
<path id="Path_26415" data-name="Path 26415" d="M11.291,9.971a4.623,4.623,0,0,1-.938,2.795.653.653,0,0,0,.057.859l.011.011a.661.661,0,0,0,.991-.06A5.97,5.97,0,0,0,11.4,6.34a.661.661,0,0,0-.989-.058l-.01.011a.655.655,0,0,0-.057.861A4.629,4.629,0,0,1,11.291,9.971Z" transform="translate(3.402 2.029)" fill="#ad0955"/>
<path id="Path_26416" data-name="Path 26416" d="M14.581,10.681A8.625,8.625,0,0,1,12.5,16.3a.649.649,0,0,0,.042.878l.009.009a.667.667,0,0,0,.943,0q.021-.021.04-.044a9.987,9.987,0,0,0-.017-12.953.667.667,0,0,0-.939-.082l-.04.037-.009.01a.651.651,0,0,0-.045.879A8.625,8.625,0,0,1,14.581,10.681Z" transform="translate(4.113 1.319)" fill="#ad0955"/>
<path id="Path_26417" data-name="Path 26417" d="M17.871,11.392a12.613,12.613,0,0,1-3.215,8.428.667.667,0,0,0,.016.917l.009.01a.655.655,0,0,0,.926.008l.022-.023a13.91,13.91,0,0,0,3.537-9.339,13.914,13.914,0,0,0-3.551-9.357A.657.657,0,0,0,14.688,2l-.021.021-.01.009a.667.667,0,0,0-.013.917,12.615,12.615,0,0,1,3.228,8.444Z" transform="translate(4.822 0.608)" fill="#ad0955"/>
</svg>

`);

export const speakerIconSVG = () => {
  return (
    <svg id="Notification_Icon_3" data-name="Notification Icon 3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<rect id="Canvas" width="24" height="24" fill="#ff13dc" opacity="0"/>
<path id="Path_26414" data-name="Path 26414" d="M4.5,7.339H.667A.667.667,0,0,0,0,8.006v6.618a.667.667,0,0,0,.667.667H4.5a.952.952,0,0,1,.621.23L9.871,20.36a.485.485,0,0,0,.8-.383V2.624a.484.484,0,0,0-.8-.381L5.119,7.11A.96.96,0,0,1,4.5,7.339Z" transform="translate(0 0.71)" fill="#ad0955"/>
<path id="Path_26415" data-name="Path 26415" d="M11.291,9.971a4.623,4.623,0,0,1-.938,2.795.653.653,0,0,0,.057.859l.011.011a.661.661,0,0,0,.991-.06A5.97,5.97,0,0,0,11.4,6.34a.661.661,0,0,0-.989-.058l-.01.011a.655.655,0,0,0-.057.861A4.629,4.629,0,0,1,11.291,9.971Z" transform="translate(3.402 2.029)" fill="#ad0955"/>
<path id="Path_26416" data-name="Path 26416" d="M14.581,10.681A8.625,8.625,0,0,1,12.5,16.3a.649.649,0,0,0,.042.878l.009.009a.667.667,0,0,0,.943,0q.021-.021.04-.044a9.987,9.987,0,0,0-.017-12.953.667.667,0,0,0-.939-.082l-.04.037-.009.01a.651.651,0,0,0-.045.879A8.625,8.625,0,0,1,14.581,10.681Z" transform="translate(4.113 1.319)" fill="#ad0955"/>
<path id="Path_26417" data-name="Path 26417" d="M17.871,11.392a12.613,12.613,0,0,1-3.215,8.428.667.667,0,0,0,.016.917l.009.01a.655.655,0,0,0,.926.008l.022-.023a13.91,13.91,0,0,0,3.537-9.339,13.914,13.914,0,0,0-3.551-9.357A.657.657,0,0,0,14.688,2l-.021.021-.01.009a.667.667,0,0,0-.013.917,12.615,12.615,0,0,1,3.228,8.444Z" transform="translate(4.822 0.608)" fill="#ad0955"/>
</svg>
  );
};

export const mergeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g id="Merge_Icon" data-name="Merge Icon" transform="translate(-0.055)">
        <g
          id="Rectangle_159461"
          data-name="Rectangle 159461"
          transform="translate(0.055)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="18" height="18" stroke="none" />
          <rect x="0.5" y="0.5" width="17" height="17" fill="none" />
        </g>
        <path
          id="merge_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
          d="M233.2-794.726l-4.979,4.979a.69.69,0,0,1-.5.206.7.7,0,0,1-.514-.216.694.694,0,0,1-.2-.511.694.694,0,0,1,.2-.512l4.145-4.16a3.872,3.872,0,0,0,.853-1.208,3.691,3.691,0,0,0,.261-1.447V-803.1l-1.315,1.315a.679.679,0,0,1-.5.2.7.7,0,0,1-.514-.219.694.694,0,0,1-.2-.511.694.694,0,0,1,.2-.512l2.444-2.453a.85.85,0,0,1,.62-.266.85.85,0,0,1,.62.266l2.453,2.453a.706.706,0,0,1,.211.5.679.679,0,0,1-.211.514.694.694,0,0,1-.511.2.694.694,0,0,1-.512-.2l-1.315-1.291v5.505a3.644,3.644,0,0,0,.27,1.456,3.975,3.975,0,0,0,.862,1.217l4.135,4.15a.706.706,0,0,1,.211.5.678.678,0,0,1-.211.514.694.694,0,0,1-.512.2.693.693,0,0,1-.511-.2Z"
          transform="translate(-224.162 806.54)"
          fill="#0265dc"
          stroke="#0265dc"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  );
};

export const swapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g id="Merge_Icon" data-name="Merge Icon" transform="translate(-0.055)">
        <g
          id="Rectangle_159461"
          data-name="Rectangle 159461"
          transform="translate(0.055)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="18" height="18" stroke="none" />
          <rect x="0.5" y="0.5" width="17" height="17" fill="none" />
        </g>
        <path
          id="Path_26480"
          data-name="Path 26480"
          d="M201.624-822.145a.582.582,0,0,1-.424-.171.568.568,0,0,1-.174-.422v-6.209L198.8-826.72a.574.574,0,0,1-.421.189.555.555,0,0,1-.418-.2.568.568,0,0,1-.19-.417.586.586,0,0,1,.19-.423l3.142-3.142a.813.813,0,0,1,.242-.158.707.707,0,0,1,.273-.053.734.734,0,0,1,.277.053.694.694,0,0,1,.235.158l3.142,3.142a.593.593,0,0,1,.189.4.581.581,0,0,1-.181.425.576.576,0,0,1-.424.181.6.6,0,0,1-.424-.194l-2.22-2.2v6.218a.563.563,0,0,1-.169.416A.571.571,0,0,1,201.624-822.145Zm5.174,7.225a.732.732,0,0,1-.277-.053.692.692,0,0,1-.235-.157l-3.142-3.142a.556.556,0,0,1-.178-.414.64.64,0,0,1,.192-.437.576.576,0,0,1,.424-.181.6.6,0,0,1,.424.194l2.2,2.219v-6.218a.563.563,0,0,1,.169-.416.572.572,0,0,1,.419-.168.583.583,0,0,1,.424.17.569.569,0,0,1,.174.423v6.209l2.228-2.228a.575.575,0,0,1,.421-.189.555.555,0,0,1,.418.2.567.567,0,0,1,.19.417.586.586,0,0,1-.19.423l-3.142,3.142a.82.82,0,0,1-.242.158A.709.709,0,0,1,206.8-814.92Z"
          transform="translate(-195.152 831.92)"
          fill="#0265dc"
          stroke="#0265dc"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  );
};

export const ConferenceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.978"
      height="14"
      viewBox="0 0 13.978 14"
    >
      <path
        id="Path_26468"
        data-name="Path 26468"
        d="M174.7-791.581V-793.7h-2.123v-1.15H174.7v-2.123h1.15v2.123h2.123v1.15h-2.123v2.123ZM177.027-783a10.778,10.778,0,0,1-4.57-1.081,15.043,15.043,0,0,1-4.305-3.066,15.151,15.151,0,0,1-3.067-4.322A10.819,10.819,0,0,1,164-796.049V-797h4.241l.806,3.343-2.52,2.448a20.508,20.508,0,0,0,1.18,1.777,13.34,13.34,0,0,0,1.271,1.479,11.668,11.668,0,0,0,1.437,1.264,20.444,20.444,0,0,0,1.828,1.206l2.526-2.5,3.207.677V-783Zm-11.016-9.287,1.788-1.734-.455-1.829h-2.2a10.1,10.1,0,0,0,.258,1.755A10.176,10.176,0,0,0,166.011-792.287Zm7.409,7.248a7.777,7.777,0,0,0,1.549.574,10.943,10.943,0,0,0,1.859.333v-2.258l-1.676-.354ZM166.011-792.287ZM173.42-785.04Z"
        transform="translate(-164 797)"
      />
    </svg>
  );
};

export const DtmfIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.633"
      height="16"
      viewBox="0 0 11.633 16"
    >
      <path
        id="dialpad_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24"
        d="M180.437-887.08a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,180.437-887.08Zm-4.483-13.333a1.285,1.285,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.285,1.285,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.285,1.285,0,0,1,175.953-900.413Zm0,4.484a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.285,1.285,0,0,1,175.953-895.93Zm0,4.483a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.285,1.285,0,0,1,.389-.944,1.285,1.285,0,0,1,.944-.389,1.285,1.285,0,0,1,.944.389,1.285,1.285,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,175.953-891.446Zm8.967-8.967a1.285,1.285,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.285,1.285,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.285,1.285,0,0,1,184.92-900.413Zm-4.483,8.967a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.285,1.285,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,180.437-891.446Zm4.483,0a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.285,1.285,0,0,1,.389-.944,1.285,1.285,0,0,1,.944-.389,1.285,1.285,0,0,1,.944.389,1.285,1.285,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,184.92-891.446Zm0-4.483a1.285,1.285,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,184.92-895.93Zm-4.483,0a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,180.437-895.93Zm0-4.484a1.286,1.286,0,0,1-.944-.389,1.286,1.286,0,0,1-.389-.944,1.286,1.286,0,0,1,.389-.944,1.286,1.286,0,0,1,.944-.389,1.286,1.286,0,0,1,.944.389,1.286,1.286,0,0,1,.389.944,1.286,1.286,0,0,1-.389.944A1.286,1.286,0,0,1,180.437-900.413Z"
        transform="translate(-174.62 903.08)"
      />
    </svg>
  );
};

export const LeaveCall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.022"
      height="14"
      viewBox="0 0 14.022 14"
    >
      <g
        id="Leave_Call"
        data-name="Leave Call"
        transform="translate(9946.14 9780.5)"
      >
        <path
          id="Path_26481"
          data-name="Path 26481"
          d="M176.593-782.005a13.088,13.088,0,0,1-4.651-1.277,14.729,14.729,0,0,1-4.041-2.891,14.521,14.521,0,0,1-2.864-4.03,13.587,13.587,0,0,1-1.277-4.635,1.017,1.017,0,0,1,.273-.816,1.029,1.029,0,0,1,.792-.346h2.317a1.047,1.047,0,0,1,.693.242,1.259,1.259,0,0,1,.4.63l.464,1.856a1.228,1.228,0,0,1-.033.58,1,1,0,0,1-.281.461l-2.049,1.995a14.278,14.278,0,0,0,1.1,1.747,13.056,13.056,0,0,0,1.32,1.532,13.272,13.272,0,0,0,1.531,1.312,13.491,13.491,0,0,0,1.776,1.1l2.1-2.052a.915.915,0,0,1,.427-.26,1.311,1.311,0,0,1,.537-.02l1.776.391a1.184,1.184,0,0,1,.637.409,1.114,1.114,0,0,1,.235.71v2.3a1.014,1.014,0,0,1-.357.792A1.049,1.049,0,0,1,176.593-782.005Zm-10.772-9.357,1.672-1.6a.159.159,0,0,0,.055-.094.207.207,0,0,0,0-.111l-.389-1.539a.183.183,0,0,0-.06-.1.173.173,0,0,0-.111-.034h-1.916a.116.116,0,0,0-.085.034.117.117,0,0,0-.034.085,9.143,9.143,0,0,0,.3,1.681A14.756,14.756,0,0,0,165.821-791.363Zm7.408,7.356a8.386,8.386,0,0,0,1.664.532q.868.181,1.612.267a.116.116,0,0,0,.085-.034.116.116,0,0,0,.034-.085v-1.911a.172.172,0,0,0-.034-.111.183.183,0,0,0-.1-.06l-1.442-.312a.141.141,0,0,0-.09,0,.219.219,0,0,0-.081.055ZM165.821-791.363ZM173.228-784.007Z"
          transform="translate(-10109.895 -8984.5)"
          fill="#f8f8f8"
        />
        <path
          id="Path_26483"
          data-name="Path 26483"
          d="M175.79-789.652l-1.444,1.463a.5.5,0,0,1-.345.164.482.482,0,0,1-.352-.164.5.5,0,0,1-.168-.358.5.5,0,0,1,.168-.358l1.444-1.444-1.463-1.463a.5.5,0,0,1-.164-.345.482.482,0,0,1,.164-.352.5.5,0,0,1,.358-.167.5.5,0,0,1,.358.167l1.444,1.444,1.463-1.463a.507.507,0,0,1,.354-.164.492.492,0,0,1,.362.164.5.5,0,0,1,.167.358.5.5,0,0,1-.167.358l-1.463,1.463,1.444,1.444a.54.54,0,0,1,.173.345.448.448,0,0,1-.154.352.5.5,0,0,1-.358.167.5.5,0,0,1-.358-.167Z"
          transform="translate(-10111.623 -8986.932)"
          fill="#f8f8f8"
        />
      </g>
    </svg>
  );
};

export const ChromeNotificationsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g
        id="Group_173451"
        data-name="Group 173451"
        transform="translate(-57 -829)"
      >
        <rect
          id="Frame"
          width="18"
          height="18"
          transform="translate(57 829)"
          fill="#f0f"
          opacity="0"
        />
        <path
          id="Path_26495"
          data-name="Path 26495"
          d="M138.111-828.748H127.722a.612.612,0,0,1-.449-.186.613.613,0,0,1-.187-.45.612.612,0,0,1,.187-.449.613.613,0,0,1,.449-.186h.35v-6.324a5.014,5.014,0,0,1,.288-1.691,6.775,6.775,0,0,1,.766-1.521l3.212,3.212H130.5l-5.332-5.332a.644.644,0,0,1-.208-.45.624.624,0,0,1,.208-.459.65.65,0,0,1,.467-.213.65.65,0,0,1,.467.213l15.133,15.158a.616.616,0,0,1,.2.442.621.621,0,0,1-.205.444.633.633,0,0,1-.452.211.638.638,0,0,1-.455-.213Zm1.1-5.1a.692.692,0,0,1-.133.419.99.99,0,0,1-.349.294.621.621,0,0,1-.44.061.843.843,0,0,1-.41-.238l-6.7-6.7a.943.943,0,0,1-.2-.3.89.89,0,0,1-.073-.354.819.819,0,0,1,.12-.439.876.876,0,0,1,.361-.318,3.738,3.738,0,0,1,.64-.266,5.19,5.19,0,0,1,.683-.16v-1.221a.9.9,0,0,1,.271-.659.9.9,0,0,1,.658-.271.9.9,0,0,1,.659.271.9.9,0,0,1,.272.659v1.221a5.224,5.224,0,0,1,3.342,1.86,5.505,5.505,0,0,1,1.3,3.645ZM133.643-826a1.759,1.759,0,0,1-1.05-.329,1.026,1.026,0,0,1-.459-.876.33.33,0,0,1,.119-.273.458.458,0,0,1,.3-.1h2.185a.456.456,0,0,1,.3.1.337.337,0,0,1,.116.274,1.025,1.025,0,0,1-.459.874A1.757,1.757,0,0,1,133.643-826Z"
          transform="translate(-67.056 1673)"
          fill="#464646"
        />
      </g>
    </svg>
  );
};